
export const Translations = {
  LearningTools: {
    Page: "LearningTools",
  },
  EmailUnsubscribe: {
    Page: "EmailUnsubscribe",
    Title: "Title",
    Checking: "Checking",
    Confirm: "Confirm",
    Unsubscribe: "Unsubscribe",
    Submitting: "Submitting",
    SuccessTitle: "SuccessTitle",
    Success: "Success",
    Essential: "Essential",
    Invalid: "Invalid",
    Error: "Error",
    RateLimited: "RateLimited",
    Retry: "Retry",
    Home: "Home",
  },
  Memocipe: "Memocipe",
  LastUpdate: "LastUpdate",
  Description: "Description",
  Language: "Language",
  WrittenLanguage: "WrittenLanguage",
  Audio: "Audio",
  AudioLanguages: "AudioLanguages",
  All: "All",
  Instructor: "Instructor",
  Back: "Back",
  General: {
    Page: "General",
    InvalidCode: "InvalidCode",
    Hide: "Hide",
    BackToHome: "BackToHome",
    PageNotFound: "PageNotFound",
    PageNotFoundDesc: "PageNotFoundDesc",
    Loading: "Loading",
    InitializingMemocipe: "InitializingMemocipe",
    CheckingAuthentication: "CheckingAuthentication",
    VerifyingCredentials: "VerifyingCredentials",
    AudioLanguage: "AudioLanguage",
    SelectAudioLanguage: "SelectAudioLanguage",
    ShowAllOptions: "ShowAllOptions",
    ChooseDifferentAudioVariant: "ChooseDifferentAudioVariant",
    CurrentAudioLanguageOnly: "CurrentAudioLanguageOnly",
    Back: "Back",
    Share: "Share",
    Close: "Close",
    Open: "Open",
    Listen: "Listen",
    Play: "Play",
    Schools: "Schools",
    LearningTools: "LearningTools",
    EducationDiscovery: "EducationDiscovery",
    Contact: "Contact",
    GetStarted: "GetStarted",
    Signin: "Signin",
    Signup: "Signup",
    Dashboard: "Dashboard",
    HOMEPAGE: "HOMEPAGE",
  },
  Videos: {
    Page: "Videos",
    PageTitle: "PageTitle",
    PageDescription: "PageDescription",
    VideoGallery: "VideoGallery",
    CurrentCulture: "CurrentCulture",
    OpenVideoLink: "OpenVideoLink",
  },
  Quiz: {
    Title: "Title",
  },
  Cart: {
    AddToCart: "Add_To_Cart",
    AddAsTrial: "Add_As_Trial",
    ChildAccount: "ChildAccount",
    PurchaseRequiresAdult: "PurchaseRequiresAdult",
    TrialNotEligible: "TrialNotEligible",
    ContinueToCheckout: "Continue_To_Checkout",
    GetForFree: "Get_for_free",
    StartTrial: "Start_Trial",
    TrialStarted: "Trial_Started",
    TrialCheckoutTitle: "TrialCheckoutTitle",
    TrialCheckoutDescription: "TrialCheckoutDescription",
    TrialCheckoutConfirm: "TrialCheckoutConfirm",
    NoCreditCard: "No_Credit_Card",
    Title: "Title",
    YourCartIsEmpty: "Your_Cart_Is_Empty",
    Remove: "Remove",
    ApplyCoupon: "Apply_Coupon",
    ClearCart: "Clear_Cart",
    CartTotals: "Cart_Totals",
    Subtotal: "Subtotal",
    ProceedToCheckout: "Proceed_To_Checkout",
    Checkout: "Checkout",
    PrivacyPolicyMsg: "PrivacyPolicyMsg",
    PrivacyPolicy: "PrivacyPolicy",
    WrongCode: "WrongCode",
    CouponCode: "CouponCode",
    RemoveFromCart: "RemoveFromCart",
    CouponCartTitle: "CouponCartTitle",
    SuccessMessage: "SuccessMessage",
    Dashboard: "Dashboard",
    ReturnToShop: "ReturnToShop",
  },
  Checkout: {
    Page: "Checkout",
    Dashboard: "Dashboard",
    ReturnToShop: "ReturnToShop",
    Line1: "Line1",
    ConfirmationTitle: "ConfirmationTitle",
    ConfirmationBody: "ConfirmationBody",
    Checkout: "Checkout",
    PurchaseRequiresAdult: "PurchaseRequiresAdult",
    TrialNotEligible: "TrialNotEligible",
    ClassroomPlanAlreadyOwned: "ClassroomPlanAlreadyOwned",
    BookingReference: "BookingReference",
    RecurringPlan: "RecurringPlan",
    Customer: "Customer",
    OrderSummary: "OrderSummary",
    Product: "Product",
    Items: "Items",
    Total: "Total",
    OrderTotal: "OrderTotal",
    PaymentMethod: "PaymentMethod",
    Type: "Type",
    Last4Digits: "Last4Digits",
    Country: "Country",
    Amount: "Amount",
    Paid: "Paid",
    Free: "Free",
    Loading: "Loading",
    UnknownError: "UnknownError",
    StripeConfigMissing: "StripeConfigMissing",
    LoadingPaymentConfig: "LoadingPaymentConfig",
  },
  VerifyEmail: {
    Login: "Login",
    Successful_verified: "Successful_verified",
    Error: "Error",
  },
  Login: {
    Page: "Login",
    Title: "Title",
    Email: "Email",
    EmailPlaceholder: "EmailPlaceholder",
    Password: "Password",
    ForgotPassword: "ForgotPassword",
    RememberMeMsg: "RememberMeMsg",
    SignupMsg: "SignupMsg",
    Signup: "Signup",
    PrivacyPolicy: "PrivacyPolicy",
    PrivacyPolicyMsg: "PrivacyPolicyMsg",
    Signin: "Signin",
    ClaimContextTitle: "ClaimContextTitle",
    ClaimContextSubtitle: "ClaimContextSubtitle",
    ClaimContextStep: "ClaimContextStep",
    ClaimContextTimeHint: "ClaimContextTimeHint",
    OrContinueWith: "OrContinueWith",
    SocialNewUserSignupRecommend: "SocialNewUserSignupRecommend",
    Error: "Error",
    ErrorUserNotVerified: "ErrorUserNotVerified",
  },
  Signup: {
    Page: "Signup",
    Title: "Title",
    ForgotPasswordTitle: "ForgotPasswordTitle",
    Name: "Name",
    NamePlaceholder: "NamePlaceholder",
    Email: "Email",
    EmailPlaceholder: "EmailPlaceholder",
    Password: "Password",
    PasswordMsg1: "PasswordMsg1",
    PasswordMsg2: "PasswordMsg2",
    PasswordMsg3: "PasswordMsg3",
    PasswordConfirmation: "PasswordConfirmation",
    PasswordConfirmationPlaceholder: "PasswordConfirmationPlaceholder",
    NewAccount: "NewAccount",
    SigninMsg: "SigninMsg",
    PrivacyPolicy: "PrivacyPolicy",
    PrivacyPolicyMsg: "PrivacyPolicyMsg",
    Signin: "Signin",
    ClaimContextTitle: "ClaimContextTitle",
    ClaimContextSubtitle: "ClaimContextSubtitle",
    ClaimContextStep: "ClaimContextStep",
    ClaimContextTimeHint: "ClaimContextTimeHint",
    ClaimContextNextStepHint: "ClaimContextNextStepHint",
    ErrorEmailInUse: "ErrorEmailInUse",
    ErrorPasswordConfirmation: "ErrorPasswordConfirmation",
    Error: "Error",
    PwdSuccessfulUpdated: "PwdSuccessfulUpdated",
    VerifyEmail: "VerifyEmail",
    VerifyEmail2: "VerifyEmail2",
    VerifyEmail3: "VerifyEmail3",
    Successful_verified: "Successful_verified",
    ForgotPWDVerifyEmail: "ForgotPWDVerifyEmail",
    ResetPwd: "ResetPwd",
    LinkExpired: "LinkExpired",
    RememberPwd: "RememberPwd",
    Submit: "Submit",
    Age: "Age",
    AgePlaceholder: "AgePlaceholder",
    TabEmail: "TabEmail",
    TabGoogleApple: "TabGoogleApple",
    ContinueWithGoogle: "ContinueWithGoogle",
    ContinueWithApple: "ContinueWithApple",
    SocialValidationError: "SocialValidationError",
    SocialSignupFailed: "SocialSignupFailed",
    SocialProviderDisabled: "SocialProviderDisabled",
    TestModeTitle: "TestModeTitle",
    TestModeDescription: "TestModeDescription",
    TestModeCode: "TestModeCode",
    TestModeCodePlaceholder: "TestModeCodePlaceholder",
    TestModeCodeRequired: "TestModeCodeRequired",
    TestModeCodeInvalid: "TestModeCodeInvalid",
    OnboardingTitle: "OnboardingTitle",
    OnboardingNameLabel: "OnboardingNameLabel",
    OnboardingNamePlaceholder: "OnboardingNamePlaceholder",
    OnboardingRoleLabel: "OnboardingRoleLabel",
    OnboardingRolePlaceholder: "OnboardingRolePlaceholder",
    OnboardingRoleTeacher: "OnboardingRoleTeacher",
    OnboardingRoleTutor: "OnboardingRoleTutor",
    OnboardingRoleParent: "OnboardingRoleParent",
    OnboardingRoleStudent: "OnboardingRoleStudent",
    OnboardingRoleRequired: "OnboardingRoleRequired",
    OnboardingProfilesLabel: "OnboardingProfilesLabel",
    OnboardingProfilesHelp: "OnboardingProfilesHelp",
    OnboardingProfileChess: "OnboardingProfileChess",
    OnboardingProfileLanguage: "OnboardingProfileLanguage",
    OnboardingProfileMaths: "OnboardingProfileMaths",
    OnboardingProfileCoding: "OnboardingProfileCoding",
    OnboardingSaving: "OnboardingSaving",
    OnboardingContinue: "OnboardingContinue",
    TesterRequestStepTitle: "TesterRequestStepTitle",
    TesterRequestStepSubtitle: "TesterRequestStepSubtitle",
    TesterRequestStepInstitutionLabel: "TesterRequestStepInstitutionLabel",
    TesterRequestStepInstitutionPlaceholder: "TesterRequestStepInstitutionPlaceholder",
    TesterRequestStepMessageLabel: "TesterRequestStepMessageLabel",
    TesterRequestStepMessagePlaceholder: "TesterRequestStepMessagePlaceholder",
    TesterRequestStepDefaultMessage: "TesterRequestStepDefaultMessage",
    TesterRequestStepMessageRequired: "TesterRequestStepMessageRequired",
    TesterRequestStepSubmit: "TesterRequestStepSubmit",
    TesterRequestStepSubmitting: "TesterRequestStepSubmitting",
    TesterRequestStepSkip: "TesterRequestStepSkip",
    TesterRequestStepBackToSignin: "TesterRequestStepBackToSignin",
    TesterRequestStepSubmitError: "TesterRequestStepSubmitError",
  },
  ForgotPwd: {
    Title: "Title",
    SubTitle: "SubTitle",
    EmailPlaceholder: "EmailPlaceholder",
    ButtonMsg: "ButtonMsg",
    RememberPwd: "RememberPwd",
    Login: "Login",
    VerifyEmail: "VerifyEmail",
    ResetPwd: "ResetPwd",
  },
  Courses: {
    Page: "Courses",
    Title: "Quizzes",
    Author: "Author",
    Chapters: "Chapters",
    Questions: "Questions",
    Enrolled: "Enrolled",
    Students: "Students",
    RelatedCourses: "Related_Courses",
    KnowDetails: "Know_Details",
    Showing: "Showing",
    Of: "Of",
    Quizzes_Per_Page: "Quizzes_Per_Page",
    Next: "Next",
    Previous: "Previous",
    Free: "Free",
    PerYear: "PerYear",
    PerYearWithVAT: "PerYearWithVAT",
    LastUpdate: "LastUpdate",
    YourQuizzes: "YourQuizzes",
  },
  Menu: {
    Home: "Home",
    Teaching: "Teaching",
    Education_Provider_Discovery: "Education_Provider_Discovery",
    MyLearning: "MyLearning",
    ParentHub: "ParentHub",
    TeachingHub: "TeachingHub",
    Courses: "Courses",
    Quizzes: "Quizzes",
    QuizLibrary: "QuizLibrary",
    QuizBank: "QuizBank",
    Tutor: "Tutor",
    Play: "Play",
    How_It_Works: "How_It_Works",
    Education_Providers_FAQ: "Education_Providers_FAQ",
    Inbox: "Inbox",
    Profile: "Profile",
    Results: "Results",
    Settings: "Settings",
    Log_Out: "Log_Out",
    Classrooms: "Classrooms",
    Bookings: "Bookings",
    Children: "Children",
    Schools: "Schools",
    SwitchToStudentWorkspace: "SwitchToStudentWorkspace",
    SwitchToTutorWorkspace: "SwitchToTutorWorkspace",
    SwitchToParentWorkspace: "SwitchToParentWorkspace",
    SwitchToClaimantWorkspace: "SwitchToClaimantWorkspace",
    OpenStudentWorkspace: "OpenStudentWorkspace",
    OpenTutorWorkspace: "OpenTutorWorkspace",
    OpenParentWorkspace: "OpenParentWorkspace",
    OpenClaimantWorkspace: "OpenClaimantWorkspace",
  },
  Parents: {
    Page: "Parents",
    Title: "Title",
    Subtitle: "Subtitle",
    LinkedChildrenTitle: "LinkedChildrenTitle",
    LinkedChildrenDescription: "LinkedChildrenDescription",
    LinkedChildrenEmpty: "LinkedChildrenEmpty",
    PurchasedQuizzesTitle: "PurchasedQuizzesTitle",
    PurchasedQuizzesDescription: "PurchasedQuizzesDescription",
    PurchasedQuizzesEmpty: "PurchasedQuizzesEmpty",
    PurchasedQuizTransferUnavailable: "PurchasedQuizTransferUnavailable",
    PurchasedQuizNeedsChild: "PurchasedQuizNeedsChild",
    OpenPurchasedQuizAction: "OpenPurchasedQuizAction",
    TransferSuccessTitle: "TransferSuccessTitle",
    TransferSuccessDescription: "TransferSuccessDescription",
    RecentTransfersTitle: "RecentTransfersTitle",
    RecentTransfersDescription: "RecentTransfersDescription",
    RecentTransfersEmpty: "RecentTransfersEmpty",
    BookingSummaryTitle: "BookingSummaryTitle",
    BookingSummaryDescription: "BookingSummaryDescription",
    BookingSummaryUpcomingLabel: "BookingSummaryUpcomingLabel",
    BookingSummaryPendingLabel: "BookingSummaryPendingLabel",
    BookingSummaryAction: "BookingSummaryAction",
    RecentTransferToLabel: "RecentTransferToLabel",
    RecentTransferDateLabel: "RecentTransferDateLabel",
    TransferUnknownChild: "TransferUnknownChild",
    ChildViewQuizzesAction: "ChildViewQuizzesAction",
    ChildTransferQuizAction: "ChildTransferQuizAction",
    ChildViewAnalyticsAction: "ChildViewAnalyticsAction",
    ChildBrowseContextTitle: "ChildBrowseContextTitle",
    ChildBrowseContextDescription: "ChildBrowseContextDescription",
    ChildTransferContextTitle: "ChildTransferContextTitle",
    ChildTransferContextDescription: "ChildTransferContextDescription",
    ChildrenCardTitle: "ChildrenCardTitle",
    ChildrenCardDescription: "ChildrenCardDescription",
    ChildrenCardAction: "ChildrenCardAction",
    QuizzesCardTitle: "QuizzesCardTitle",
    QuizzesCardDescription: "QuizzesCardDescription",
    QuizzesCardAction: "QuizzesCardAction",
    TransfersCardTitle: "TransfersCardTitle",
    TransfersCardDescription: "TransfersCardDescription",
    TransfersCardAction: "TransfersCardAction",
    LightScopeTitle: "LightScopeTitle",
    LightScopeDescription: "LightScopeDescription",
    ChildrenPageTitle: "ChildrenPageTitle",
    ChildrenPageSubtitle: "ChildrenPageSubtitle",
    ChildrenEmptyTitle: "ChildrenEmptyTitle",
    ChildrenEmptyDescription: "ChildrenEmptyDescription",
    ManagedInvitationsTitle: "ManagedInvitationsTitle",
    ManagedInvitationsDescription: "ManagedInvitationsDescription",
    ManagedInvitationFriendType: "ManagedInvitationFriendType",
    ManagedInvitationFriendCannotBeAccepted: "ManagedInvitationFriendCannotBeAccepted",
    ChildSubscriptionsTitle: "ChildSubscriptionsTitle",
    ChildSubscriptionsDescription: "ChildSubscriptionsDescription",
    ChildSubscriptionsEmpty: "ChildSubscriptionsEmpty",
    ChildSubscriptionsShowArchived: "ChildSubscriptionsShowArchived",
    ChildSubscriptionsHideArchived: "ChildSubscriptionsHideArchived",
    ChildSubscriptionArchiveConfirm: "ChildSubscriptionArchiveConfirm",
    ChildSubscriptionRestoreConfirm: "ChildSubscriptionRestoreConfirm",
    ChildSubscriptionArchivedSuccess: "ChildSubscriptionArchivedSuccess",
    ChildSubscriptionRestoredSuccess: "ChildSubscriptionRestoredSuccess",
  },
  Homepage: {
    HeroEyebrow: "HeroEyebrow",
    Login_Btn: "Login",
    Register_Btn: "Register",
    View_all_courses: "View_all_courses",
    View_all_quizzes: "View_all_quizzes",
    View_quiz_creation_plans: "View_quiz_creation_plans",
    View_classroom_plans: "View_classroom_plans",
    View_tutoring_centres_search: "View_tutoring_centres_search",
    View_math_practice: "View_math_practice",
    HeroTitleStart: "HeroTitleStart",
    HeroTitleEnd: "HeroTitleEnd",
    HeroDescriptionPrimary: "HeroDescriptionPrimary",
    HeroDescriptionSecondary: "HeroDescriptionSecondary",
    MetaTitle: "MetaTitle",
    MetaDescription: "MetaDescription",
    HeroPrimaryCta: "HeroPrimaryCta",
    AudienceSectionTitle: "AudienceSectionTitle",
    AudienceSectionDescription: "AudienceSectionDescription",
    AudienceTutorsTitle: "AudienceTutorsTitle",
    AudienceTutorsDescription: "AudienceTutorsDescription",
    AudienceStudentsTitle: "AudienceStudentsTitle",
    AudienceStudentsDescription: "AudienceStudentsDescription",
    AudienceParentsTitle: "AudienceParentsTitle",
    AudienceParentsDescription: "AudienceParentsDescription",
    WorkflowSectionTitleV2: "WorkflowSectionTitleV2",
    WorkflowSectionDescriptionV2: "WorkflowSectionDescriptionV2",
    WorkflowTeachTitle: "WorkflowTeachTitle",
    WorkflowTeachDescription: "WorkflowTeachDescription",
    WorkflowTrackTitle: "WorkflowTrackTitle",
    WorkflowTrackDescription: "WorkflowTrackDescription",
    WorkflowEngageTitle: "WorkflowEngageTitle",
    WorkflowEngageDescription: "WorkflowEngageDescription",
    TryNowTitle: "TryNowTitle",
    TryNowDescription: "TryNowDescription",
    TryNowCta: "TryNowCta",
    PlansPromoTitle: "PlansPromoTitle",
    PlansPromoDescription: "PlansPromoDescription",
    PlansPromoDescriptionPart1: "PlansPromoDescriptionPart1",
    PlansPromoDescriptionPart2: "PlansPromoDescriptionPart2",
    PlansPromoDescriptionPart3: "PlansPromoDescriptionPart3",
    Message1_part1: "Message1_part1",
    Message1_part2: "Message1_part2",
    VideoTitle: "VideoTitle",
    VideoDescription: "VideoDescription",
    DiscoveryEyebrow: "DiscoveryEyebrow",
    DiscoveryTitle: "DiscoveryTitle",
    DiscoveryDescription: "DiscoveryDescription",
    DiscoveryLearningToolsCta: "DiscoveryLearningToolsCta",
    DiscoveryFreeHint: "DiscoveryFreeHint",
    DiscoveryOwnerCta: "DiscoveryOwnerCta",
    DiscoveryOwnerHint: "DiscoveryOwnerHint",
    DiscoverySearchTitle: "DiscoverySearchTitle",
    DiscoverySearchDescription: "DiscoverySearchDescription",
    DiscoveryTeaserTitle: "DiscoveryTeaserTitle",
    DiscoveryTeaserDescription: "DiscoveryTeaserDescription",
    DiscoveryTeaserCta: "DiscoveryTeaserCta",
    LearningToolsHeroTitleStart: "LearningToolsHeroTitleStart",
    LearningToolsHeroTitleEnd: "LearningToolsHeroTitleEnd",
    LearningToolsHeroDescriptionPrimary: "LearningToolsHeroDescriptionPrimary",
    LearningToolsHeroDescriptionSecondary: "LearningToolsHeroDescriptionSecondary",
    LearningFlowTitle: "LearningFlowTitle",
    LearningFlowDescription: "LearningFlowDescription",
    LearningFlowClassroomsTitle: "LearningFlowClassroomsTitle",
    LearningFlowClassroomsDescription: "LearningFlowClassroomsDescription",
    LearningFlowClassroomsPoint1: "LearningFlowClassroomsPoint1",
    LearningFlowClassroomsPoint2: "LearningFlowClassroomsPoint2",
    LearningFlowClassroomsPoint3: "LearningFlowClassroomsPoint3",
    LearningFlowQuizzesTitle: "LearningFlowQuizzesTitle",
    LearningFlowQuizzesDescription: "LearningFlowQuizzesDescription",
    LearningFlowQuizzesPoint1: "LearningFlowQuizzesPoint1",
    LearningFlowQuizzesPoint2: "LearningFlowQuizzesPoint2",
    LearningFlowQuizzesPoint3: "LearningFlowQuizzesPoint3",
    LearningFlowOpenCta: "LearningFlowOpenCta",
    LearningFlowTestNowCta: "LearningFlowTestNowCta",
    LearningFlowProfileClassroomsLabel: "LearningFlowProfileClassroomsLabel",
    LearningFlowProfileGeneral: "LearningFlowProfileGeneral",
    LearningFlowProfileMaths: "LearningFlowProfileMaths",
    LearningFlowProfileLanguage: "LearningFlowProfileLanguage",
    LearningFlowProfileChess: "LearningFlowProfileChess",
    LearningToolsMathsHubsTitle: "LearningToolsMathsHubsTitle",
    LearningToolsMathsHubsDescription: "LearningToolsMathsHubsDescription",
    LearningToolsTimesTablesTitle: "LearningToolsTimesTablesTitle",
    LearningToolsTimesTablesDescription: "LearningToolsTimesTablesDescription",
    LearningToolsAdditionFactsTitle: "LearningToolsAdditionFactsTitle",
    LearningToolsAdditionFactsDescription: "LearningToolsAdditionFactsDescription",
    LearningToolsSubtractionFactsTitle: "LearningToolsSubtractionFactsTitle",
    LearningToolsSubtractionFactsDescription: "LearningToolsSubtractionFactsDescription",
    LearningToolsDivisionFactsTitle: "LearningToolsDivisionFactsTitle",
    LearningToolsDivisionFactsDescription: "LearningToolsDivisionFactsDescription",
    LearningToolsOpenCta: "LearningToolsOpenCta"
  },
  ChessFeatures: {
    Page: "ChessFeatures",
    MetaTitle: "MetaTitle",
    MetaDescription: "MetaDescription",
    PageTitle: "PageTitle",
    Eyebrow: "Eyebrow",
    HeroTitle: "HeroTitle",
    HeroDescription: "HeroDescription",
    TutorWorkspaceCta: "TutorWorkspaceCta",
    ClassroomPlansCta: "ClassroomPlansCta",
    ClassroomSectionTitle: "ClassroomSectionTitle",
    ClassroomBenefitStructuredTitle: "ClassroomBenefitStructuredTitle",
    ClassroomBenefitStructuredDescription: "ClassroomBenefitStructuredDescription",
    ClassroomBenefitLessonTitle: "ClassroomBenefitLessonTitle",
    ClassroomBenefitLessonDescription: "ClassroomBenefitLessonDescription",
    ClassroomBenefitResourcesTitle: "ClassroomBenefitResourcesTitle",
    ClassroomBenefitResourcesDescription: "ClassroomBenefitResourcesDescription",
    PgnSectionTitle: "PgnSectionTitle",
    PgnBenefitUploadTitle: "PgnBenefitUploadTitle",
    PgnBenefitUploadDescription: "PgnBenefitUploadDescription",
    PgnBenefitCollectionsTitle: "PgnBenefitCollectionsTitle",
    PgnBenefitCollectionsDescription: "PgnBenefitCollectionsDescription",
    PgnBenefitReplayTitle: "PgnBenefitReplayTitle",
    PgnBenefitReplayDescription: "PgnBenefitReplayDescription",
    TacticsSectionTitle: "TacticsSectionTitle",
    TacticsBenefitExercisesTitle: "TacticsBenefitExercisesTitle",
    TacticsBenefitExercisesDescription: "TacticsBenefitExercisesDescription",
    TacticsBenefitAutocorrectTitle: "TacticsBenefitAutocorrectTitle",
    TacticsBenefitAutocorrectDescription: "TacticsBenefitAutocorrectDescription",
    TacticsBenefitRecallTitle: "TacticsBenefitRecallTitle",
    TacticsBenefitRecallDescription: "TacticsBenefitRecallDescription",
    AnalyticsSectionTitle: "AnalyticsSectionTitle",
    AnalyticsBenefitVisibilityTitle: "AnalyticsBenefitVisibilityTitle",
    AnalyticsBenefitVisibilityDescription: "AnalyticsBenefitVisibilityDescription",
    AnalyticsBenefitFollowupTitle: "AnalyticsBenefitFollowupTitle",
    AnalyticsBenefitFollowupDescription: "AnalyticsBenefitFollowupDescription",
    AnalyticsBenefitProgramTitle: "AnalyticsBenefitProgramTitle",
    AnalyticsBenefitProgramDescription: "AnalyticsBenefitProgramDescription",
    ImagePlaceholderLabel: "ImagePlaceholderLabel",
    ImagePlaceholderDashboard: "ImagePlaceholderDashboard",
    ImagePlaceholderTactics: "ImagePlaceholderTactics",
    FinalCtaTitle: "FinalCtaTitle",
    FinalCtaDescription: "FinalCtaDescription",
    FinalTutorWorkspaceCta: "FinalTutorWorkspaceCta",
    FinalPlanDetailsCta: "FinalPlanDetailsCta",
    PlanNote: "PlanNote",
  },
  TheTeam: {
    Page: "TheTeam",
    Title: "Title",
    HeroEyebrow: "HeroEyebrow",
    HeroIntro1: "HeroIntro1",
    HeroIntro2: "HeroIntro2",
    ProfileLabel: "ProfileLabel",
    ResponsibilitiesLabel: "ResponsibilitiesLabel",
    ExternalLabel: "ExternalLabel",
    ExternalTitle: "ExternalTitle",
    ExternalDescription: "ExternalDescription",
    AdilsonSummary1: "AdilsonSummary1",
    AdilsonSummary2: "AdilsonSummary2",
    AdilsonSummary3: "AdilsonSummary3",
    GuildynSummary1: "GuildynSummary1",
    GuildynSummary2: "GuildynSummary2",
    GuildynSummary3: "GuildynSummary3",
    ExternalPoint1: "ExternalPoint1",
    ExternalPoint2: "ExternalPoint2",
    ExternalPoint3: "ExternalPoint3",
  },
  Inbox: {
    Page: "Inbox",
    Title: "Title",
    Messages: "Messages",
    From: "From",
    Date: "Date",
    Message: "Message",
    Send: "Send",
    Empty: "Empty",
    MessageTo: "MessageTo",
    SearchUser: "SearchUser",
    TypeMessage: "TypeMessage",
    LoadMore: "LoadMore",
    FailedToBlock: "FailedToBlock",
    PleaseTryAgain: "PleaseTryAgain",
    UnblockMsg: "UnblockMsg",
    BlockMsg: "BlockMsg",
    DeleteMsg: "DeleteMsg",
    InviteFriendTitle: "InviteFriendTitle",
    Invitations: "Invitations",
    Contacts: "Contacts",
    AddUser: "AddUser",
    ContactsTitle: "ContactsTitle",
    Me: "Me",
    SelectAUser: "SelectAUser",
    ChildMessagingDisabledTitle: "ChildMessagingDisabledTitle",
    ChildMessagingDisabledDescription: "ChildMessagingDisabledDescription",
    InvitationAccepted: "InvitationAccepted",
    InvitationDeclined: "InvitationDeclined",
  },
  Contacts: {
    Page: "Contacts",
    Title: "Title",
    SearchUser: "SearchUser",
    Empty: "Empty",
    RelationshipParent: "RelationshipParent",
    RelationshipChild: "RelationshipChild",
    RelationshipTutor: "RelationshipTutor",
    ParentOfChildren: "ParentOfChildren",
    TutorOfChildren: "TutorOfChildren",
    MessagingManagedByParents: "MessagingManagedByParents",
    RemoveContactMsg: "RemoveContactMsg",
    RemoveContactMsg2: "RemoveContactMsg2"
  },
  Dashboard: {
    Chapters: "Chapters",
    Show: "Show",
    Hide: "Hide",
    Title: "Title",
    Trial: "Trial",
    Owned: "Owned",
    TrialEnded: "TrialEnded",
    Day: "Day",
    Days: "Days",
    Left: "Left",
    PurchasedQuiz: "PurchasedQuiz",
    Empty_list: "Empty_list",
    Find_Btn: "Find_Btn",
    Search_placeholder: "Search_placeholder",
    Learn: "Learn",
    Learned: "Learned",
    Completed: "Completed",
    Review: "Review",
    ReviewLevel: "ReviewLevel",
    Quiz: "Quiz",
    AddQuiz: "AddQuiz",
    ShowcaseText: "ShowcaseText",
    AudioLanguage: "AudioLanguage",
    SelectAudioLanguage: "SelectAudioLanguage",
    ShowAllOptions: "ShowAllOptions",
    ChooseDifferentAudioVariant: "ChooseDifferentAudioVariant",
    CurrentAudioLanguageOnly: "CurrentAudioLanguageOnly",
    Archived: "Archived",
    Active: "Active",
    Activate: "Activate",
    Archive: "Archive",
    Start: "Start",
    StartPlaying: "StartPlaying",
    Transfer: "Transfer",
    ShowAll: "ShowAll",
    CurrentLesson: "CurrentLesson",
    AssignedQuizzes: "AssignedQuizzes",
    QuizzesDue: "QuizzesDue",
    DueQuizzes: "DueQuizzes",
    MissedQuizzes: "MissedQuizzes",
    SubmittedQuizzes: "SubmittedQuizzes",
    AnalyticsCardTitle: "AnalyticsCardTitle",
    AnalyticsCardDescription: "AnalyticsCardDescription",
    AnalyticsCardAction: "AnalyticsCardAction",
    AnalyticsPageTitle: "AnalyticsPageTitle",
    AnalyticsPageSubtitle: "AnalyticsPageSubtitle",
    AnalyticsSummaryTitle: "AnalyticsSummaryTitle",
    AnalyticsFiltersTitle: "AnalyticsFiltersTitle",
    AnalyticsFiltersDescription: "AnalyticsFiltersDescription",
    AnalyticsCourseFilterLabel: "AnalyticsCourseFilterLabel",
    AnalyticsQuizFilterLabel: "AnalyticsQuizFilterLabel",
    AnalyticsAllCourses: "AnalyticsAllCourses",
    AnalyticsAllQuizzes: "AnalyticsAllQuizzes",
    AnalyticsClearFilters: "AnalyticsClearFilters",
    AnalyticsFilteredBy: "AnalyticsFilteredBy",
    AnalyticsRecentSessionsTitle: "AnalyticsRecentSessionsTitle",
    AnalyticsRecentSessionsDescription: "AnalyticsRecentSessionsDescription",
    AnalyticsFilteredSessionsDescription: "AnalyticsFilteredSessionsDescription",
    AnalyticsEmptyTitle: "AnalyticsEmptyTitle",
    AnalyticsEmptyDescription: "AnalyticsEmptyDescription",
    AnalyticsFilteredEmptyTitle: "AnalyticsFilteredEmptyTitle",
    AnalyticsFilteredEmptyDescription: "AnalyticsFilteredEmptyDescription",
    AnalyticsSessionsStat: "AnalyticsSessionsStat",
    AnalyticsStudyTimeStat: "AnalyticsStudyTimeStat",
    AnalyticsAccuracyStat: "AnalyticsAccuracyStat",
    AnalyticsBestScoreStat: "AnalyticsBestScoreStat",
    AnalyticsCompleted: "AnalyticsCompleted",
    AnalyticsAbandoned: "AnalyticsAbandoned",
    AnalyticsAverageScore: "AnalyticsAverageScore",
    AnalyticsQuestionsAnswered: "AnalyticsQuestionsAnswered",
    AnalyticsCardsViewed: "AnalyticsCardsViewed",
    AnalyticsAnswersRevealed: "AnalyticsAnswersRevealed",
    AnalyticsLastActive: "AnalyticsLastActive",
    AnalyticsMode: "AnalyticsMode",
    AnalyticsStatus: "AnalyticsStatus",
    AnalyticsDuration: "AnalyticsDuration",
    AnalyticsScore: "AnalyticsScore",
    AnalyticsStarted: "AnalyticsStarted",
    AnalyticsNoScore: "AnalyticsNoScore",
  },
  Course_status: {
    Active: "Active",
    Archived: "Archived",
    My_items: "My_items",
    All: "All",
  },
  Loading: "Loading",
  Learn: {
    Title: "Title",
    Questions: "Questions",
    Next: "Next",
    Finish: "Finish",
    Restart: "Restart",
    Previous: "Previous",
    ShowQuestion: "ShowQuestion",
    ShowAnswer: "ShowAnswer",
    Correct: "Correct",
    LastQuestionNotice: "LastQuestionNotice",
    AudioPlaybackUnsupported: "AudioPlaybackUnsupported",
    EmptyTitle: "EmptyTitle",
    EmptyDescription: "EmptyDescription",
  },
  Friends: {
    Page: "Friends",
    Title: "Title",
    EmailPlaceholder: "EmailPlaceholder",
    Search: "Search",
    Email: "Email",
    AddFriend: "AddFriend",
    AddChild: "AddChild",
    InviteChildTitle: "InviteChildTitle",
    InviteChildSubtitle: "InviteChildSubtitle",
    ParentInviteRequiresAdult: "ParentInviteRequiresAdult",
    TutorAddChildTitle: "TutorAddChildTitle",
    TutorAddChildDescription: "TutorAddChildDescription",
    Accept: "Accept",
    Decline: "Decline",
    Cancel: "Cancel",
    ContactInvitationsManagedByParents: "ContactInvitationsManagedByParents",
    ChildContactFriendInvitationsDisabled: "ChildContactFriendInvitationsDisabled",
    InvitationsSent: "InvitationsSent",
    UserNotFound: "UserNotFound",
    InvitationCooldown: "InvitationCooldown",
    InvitationInvalidUser: "InvitationInvalidUser",
    InvitationSelfNotAllowed: "InvitationSelfNotAllowed",
    InvitationPendingExists: "InvitationPendingExists",
    InvitationAlreadyContacts: "InvitationAlreadyContacts",
    InvitationChildRequiresStudentRole: "InvitationChildRequiresStudentRole",
    InvitationChildBirthYearRequired: "InvitationChildBirthYearRequired",
    InvitationChildMustBeUnder16: "InvitationChildMustBeUnder16",
    InvitationChildParentLimitReached: "InvitationChildParentLimitReached",
    InvitationAlreadyLinkedChild: "InvitationAlreadyLinkedChild",
    InvitationAlreadyLinkedParent: "InvitationAlreadyLinkedParent",
    InvitationAlreadyLinkedOther: "InvitationAlreadyLinkedOther",
    InviteRequestFailed: "InviteRequestFailed",
    Requests: "Requests",
    JoinClassroom: "JoinClassroom",
    JoinByCodeTitle: "JoinByCodeTitle",
    JoinByCodeSubtitle: "JoinByCodeSubtitle",
    JoinByCodePlaceholder: "JoinByCodePlaceholder",
    JoinByCodeButton: "JoinByCodeButton",
    JoinByCodeJoining: "JoinByCodeJoining",
    JoinByCodeRequired: "JoinByCodeRequired",
    JoinByCodeInvalidOrExpired: "JoinByCodeInvalidOrExpired",
    JoinByCodeMissingTarget: "JoinByCodeMissingTarget",
    JoinByCodeClassroomNotFound: "JoinByCodeClassroomNotFound",
    JoinByCodeQuizNotFound: "JoinByCodeQuizNotFound",
    JoinByCodeMissingOwner: "JoinByCodeMissingOwner",
    JoinByCodeOwnerCannotJoinClassroom: "JoinByCodeOwnerCannotJoinClassroom",
    JoinByCodeOwnerCannotJoinQuiz: "JoinByCodeOwnerCannotJoinQuiz",
    JoinByCodeInvitationWaiting: "JoinByCodeInvitationWaiting",
    JoinByCodeSuccess: "JoinByCodeSuccess",
    JoinByCodeAlreadyJoined: "JoinByCodeAlreadyJoined",
    JoinByCodeOpenClassroom: "JoinByCodeOpenClassroom",
    JoinByCodeError: "JoinByCodeError",
    ClassroomInvitationReceived: "ClassroomInvitationReceived",
    ClassroomInvitationSent: "ClassroomInvitationSent",
    ChildInvitationQuestion: "ChildInvitationQuestion",
    ChildInvitationReceived: "ChildInvitationReceived",
    ChildInvitationSent: "ChildInvitationSent",
    JoinByCodeRequested: "JoinByCodeRequested",
  },
  Play: {
    Page: "Play",
    Title: "Title",
    Minutes: "Minutes",
    Min: "Min",
    AnonymousTitle: "AnonymousTitle",
    AnonymousDemoTitle: "AnonymousDemoTitle",
    AnonymousDemoMessage: "AnonymousDemoMessage",
    AssignedQuizzesTab: "AssignedQuizzesTab",
    MathPracticeTab: "MathPracticeTab",
    Results: "Results",
    Questions: "Questions",
    Answers: "Answers",
    IsCorrect: "IsCorrect",
    Seconds: "Seconds",
    Sec: "Sec",
    StartIn: "StartIn",
    TimeLeft: "TimeLeft",
    QuizCompleted: "QuizCompleted",
    Battle: "Battle",
    PlayWithFriend: "PlayWithFriend",
    BattleIn: "BattleIn",
    NoMessages: "NoMessages",
    NoAssignedQuizzes: "NoAssignedQuizzes",
    NoMathPractice: "NoMathPractice",
    TitleForPlay: "TitleForPlay",
    QuizTitle: "QuizTitle",
    Continue: "Continue",
    AnswerRequired: "AnswerRequired",
    QuizRunning: "QuizRunning",
    SignedUserLimit: "SignedUserLimit",
    AnonymousUserLimit: "AnonymousUserLimit",
    Skip: "Skip",
    Accept: "Accept",
    ChessMovePrompt: "ChessMovePrompt",
    ChessSelectedMove: "ChessSelectedMove",
    ChessResetMove: "ChessResetMove",
  },
  Racer: {
    Page: "Racer",
    Title: "Title",
    RegistrationTitle: "RegistrationTitle",
    JoinPageTitle: "JoinPageTitle",
    ChooseBattleTitle: "ChooseBattleTitle",
    ChooseBattleHelp: "ChooseBattleHelp",
    CreateBattle: "CreateBattle",
    CreateBattleHelp: "CreateBattleHelp",
    JoinExistingBattle: "JoinExistingBattle",
    JoinExistingBattleHelp: "JoinExistingBattleHelp",
    Name: "Name",
    Start: "Start",
    Players: "Players",
    Results: "Results",
    Confirmed: "Confirmed",
    Questions: "Questions",
    Answers: "Answers",
    IsCorrect: "IsCorrect",
    Copy: "Copy",
    OrIviteFriends: "OrInviteFriends",
    Select_Part1: "Select_Part1",
    Select_Part2: "Select_Part2",
    BattleCodeTitle: "BattleCodeTitle",
    BattleCodeHelp: "BattleCodeHelp",
    BattleCodeLabel: "BattleCodeLabel",
    BattleCodePlaceholder: "BattleCodePlaceholder",
    BattleCodeExpiresAt: "BattleCodeExpiresAt",
    CopyJoinLink: "CopyJoinLink",
    JoinLinkCopied: "JoinLinkCopied",
    OpenLobby: "OpenLobby",
    JoinPageHelp: "JoinPageHelp",
    JoinBattle: "JoinBattle",
    JoinCodeInvalid: "JoinCodeInvalid",
    JoinCodeExpired: "JoinCodeExpired",
    JoinCodeLookupError: "JoinCodeLookupError",
    Continue: "Continue",
    Submit: "Submit",
    StartMessage: "StartMessage",
    StartMessage2: "StartMessage2",
  },
  // Quiz not used in the current version, commenting out
  // Quiz: {
  //   Quiz: "Quiz",
  //   Title: "Title",
  //   TitleForPlay: "TitleForPlay",
  // },
  Review: {
    Title: "Title",
    Results: "Results",
    Questions: "Questions",
    Answers: "Answers",
    CorrectAnswers: "CorrectAnswers",
  },
  Leaderboard: {
    Page: "Leaderboard",
    Title: "Title",
    Season: "Season",
    StartDate: "StartDate",
    EndDate: "EndDate",
    Time: "Time",
    CorrectAnswers: "CorrectAnswers",
    AchievedAt: "AchievedAt",
    Position: "Position",
    AllTimeRecord: "AllTimeRecord",
    RemainingTime: "RemainingTime",
    SeasonEnding: "SeasonEnding",
    Rank: "Rank",
    User: "User",
    Score: "Score",
    Details: "Details",
  },
  HowItWorks: {
    Page: "HowItWorks",
    Title: "Title",
    RoleSelectorLabel: "RoleSelectorLabel",
    StudentTab: "StudentTab",
    ParentTab: "ParentTab",
    TutorTab: "TutorTab",
    StudentOverviewTitle: "StudentOverviewTitle",
    StudentOverviewBody: "StudentOverviewBody",
    StudentModesTitle: "StudentModesTitle",
    StudentModesIntro: "StudentModesIntro",
    StudentModesLearn: "StudentModesLearn",
    StudentModesQuiz: "StudentModesQuiz",
    StudentModesSpacedRepetition: "StudentModesSpacedRepetition",
    StudentSpacedRepetitionTitle: "StudentSpacedRepetitionTitle",
    StudentSpacedRepetitionBody1: "StudentSpacedRepetitionBody1",
    StudentSpacedRepetitionBody2: "StudentSpacedRepetitionBody2",
    StudentSpacedRepetitionTableTitle: "StudentSpacedRepetitionTableTitle",
    Day: "Day",
    Days: "Days",
    StudentQuizPlayTitle: "StudentQuizPlayTitle",
    StudentQuizPlayBody1: "StudentQuizPlayBody1",
    StudentQuizPlayBody2: "StudentQuizPlayBody2",
    StudentMessagesTitle: "StudentMessagesTitle",
    StudentMessagesBody1: "StudentMessagesBody1",
    StudentMessagesBody2: "StudentMessagesBody2",
    StudentMessagesItem1: "StudentMessagesItem1",
    StudentMessagesItem2: "StudentMessagesItem2",
    StudentMessagesItem3: "StudentMessagesItem3",
    ParentOverviewTitle: "ParentOverviewTitle",
    ParentOverviewBody: "ParentOverviewBody",
    ParentQuizTransferTitle: "ParentQuizTransferTitle",
    ParentQuizTransferBody1: "ParentQuizTransferBody1",
    ParentQuizTransferBody2: "ParentQuizTransferBody2",
    ParentSafetyTitle: "ParentSafetyTitle",
    ParentSafetyIntro: "ParentSafetyIntro",
    ParentSafetyItem1: "ParentSafetyItem1",
    ParentSafetyItem2: "ParentSafetyItem2",
    ParentSafetyItem3: "ParentSafetyItem3",
    ParentSafetyOutro: "ParentSafetyOutro",
    TutorOverviewTitle: "TutorOverviewTitle",
    TutorOverviewBody: "TutorOverviewBody",
    TutorQuizCreationTitle: "TutorQuizCreationTitle",
    TutorQuizCreationBody: "TutorQuizCreationBody",
    TutorClassroomsTitle: "TutorClassroomsTitle",
    TutorClassroomsBody: "TutorClassroomsBody",
    TutorBookingsTitle: "TutorBookingsTitle",
    TutorBookingsBody: "TutorBookingsBody",
    TutorCreditsTitle: "TutorCreditsTitle",
    TutorCreditsBody: "TutorCreditsBody",
    TutorAnalyticsTitle: "TutorAnalyticsTitle",
    TutorAnalyticsBody: "TutorAnalyticsBody",
  },
  QuizFeatures: {
    Page: "QuizFeatures",
    PageTitle: "PageTitle",
    PageSubtitle: "PageSubtitle",
    FreeTier: "FreeTier",
    StandardTier: "StandardTier",
    PremiumTier: "PremiumTier",
    SchoolTier: "SchoolTier",
    MaxActiveQuizzes: "MaxActiveQuizzes",
    MaxCreationsPerMonth: "MaxCreationsPerMonth",
    MaxAssignedStudentsPerQuiz: "MaxAssignedStudentsPerQuiz",
    QuizType: "QuizType",
    LearnMode: "LearnMode",
    StandardPlusLearnMode: "StandardPlusLearnMode",
    RepeatableQuizModes: "RepeatableQuizModes",
    RepeatableQuizSeats: "RepeatableQuizSeats",
    ReviewAndPlayModes: "ReviewAndPlayModes",
    UsesQuizSeatLimit: "UsesQuizSeatLimit",
    MaxLiveParticipantsPerQuiz: "MaxLiveParticipantsPerQuiz",
    MaxTotalActiveStudentsPerAccount: "MaxTotalActiveStudentsPerAccount",
    MaxShareLinks: "MaxShareLinks",
    GoogleDriveAccess: "GoogleDriveAccess",
    HostedLibraryStorage: "HostedLibraryStorage",
    SpacedRepetition: "SpacedRepetition",
    QuizPlay: "QuizPlay",
    StudentsUnit: "StudentsUnit",
    Included: "Included",
    HostedLibraryReusableAssets: "HostedLibraryReusableAssets",
    GoogleDriveAttachments: "GoogleDriveAttachments",
    Unlimited: "Unlimited",
    Custom: "Custom",
    MostPopular: "MostPopular",
    AdvancedOptions: "AdvancedOptions",
    AnalyticsAndReporting: "AnalyticsAndReporting",
    BasicProgressTracking: "BasicProgressTracking",
    BasicQuizAndReview: "BasicQuizAndReview",
    BulkImport: "BulkImport",
    AdvancedAnalytics: "AdvancedAnalytics",
    CoTeacher: "CoTeacher",
    FoldersAndTags: "FoldersAndTags",
    PremiumAdvancedOptionsPlus: "PremiumAdvancedOptionsPlus",
    PrioritySupport: "PrioritySupport",
    CustomOnboarding: "CustomOnboarding",
    StartFree: "StartFree",
    Upgrade: "Upgrade",
    UpgradePremium: "UpgradePremium",
    ContactSales: "ContactSales",
    InDevelopment: "InDevelopment",
    QuizPlan: "QuizPlan",
    ViewClassroomPlans: "ViewClassroomPlans",
    Price: "Price",
    Month: "Month",
    InfoText: "InfoText",
  },
  ClassroomFeatures: {
    Page: "ClassroomFeatures",
    PageTitle: "PageTitle",
    PageSubtitle: "PageSubtitle",
    FreeTier: "FreeTier",
    StandardTier: "StandardTier",
    PremiumTier: "PremiumTier",
    SchoolTier: "SchoolTier",
    MaxActiveClassrooms: "MaxActiveClassrooms",
    MaxStudentsPerClassroom: "MaxStudentsPerClassroom",
    MaxLessonsPerClassroom: "MaxLessonsPerClassroom",
    MaxContentItemsPerClassroom: "MaxContentItemsPerClassroom",
    MaxCoTeachersPerClassroom: "MaxCoTeachersPerClassroom",
    MaxTotalActiveStudentsPerAccount: "MaxTotalActiveStudentsPerAccount",
    QuizType: "QuizType",
    LearnMode: "LearnMode",
    StandardPlusLearnMode: "StandardPlusLearnMode",
    RepeatableQuizModes: "RepeatableQuizModes",
    RepeatableQuizSeats: "RepeatableQuizSeats",
    ReviewAndPlayModes: "ReviewAndPlayModes",
    UsesQuizSeatLimit: "UsesQuizSeatLimit",
    GoogleDriveAccess: "GoogleDriveAccess",
    HostedLibraryStorage: "HostedLibraryStorage",
    SpacedRepetition: "SpacedRepetition",
    QuizPlay: "QuizPlay",
    StudentsUnit: "StudentsUnit",
    Included: "Included",
    HostedLibraryReusableAssets: "HostedLibraryReusableAssets",
    GoogleDriveAttachments: "GoogleDriveAttachments",
    IncludedQuizPlan: "IncludedQuizPlan",
    Unlimited: "Unlimited",
    Custom: "Custom",
    MostPopular: "MostPopular",
    AdvancedOptions: "AdvancedOptions",
    AnalyticsAndReporting: "AnalyticsAndReporting",
    BasicProgressTracking: "BasicProgressTracking",
    BasicQuizAndReview: "BasicQuizAndReview",
    BulkImport: "BulkImport",
    AdvancedAnalytics: "AdvancedAnalytics",
    ExportReports: "ExportReports",
    CoTeacher: "CoTeacher",
    FoldersAndTags: "FoldersAndTags",
    FullAnalyticsAndReporting: "FullAnalyticsAndReporting",
    AiAssistedContentWorkflows: "AiAssistedContentWorkflows",
    InstitutionReadyCollaboration: "InstitutionReadyCollaboration",
    PremiumAdvancedOptionsPlus: "PremiumAdvancedOptionsPlus",
    PrioritySupport: "PrioritySupport",
    CustomOnboarding: "CustomOnboarding",
    StartFree: "StartFree",
    Upgrade: "Upgrade",
    UpgradePremium: "UpgradePremium",
    ContactSales: "ContactSales",
    InDevelopment: "InDevelopment",
    PaidTierSoonBadge: "PaidTierSoonBadge",
    PaidTierComingSoon: "PaidTierComingSoon",
    PaidTierTestingCta: "PaidTierTestingCta",
    PaidTierTestingApprovalNote: "PaidTierTestingApprovalNote",
    PaidTierTestingLearnMore: "PaidTierTestingLearnMore",
    ClassroomPlan: "ClassroomPlan",
    ViewQuizPlans: "ViewQuizPlans",
    Price: "Price",
    Month: "Month",
    Monthly: "Monthly",
    Yearly: "Yearly",
    InfoText: "InfoText",
    TesterInvitationSubtitle: "TesterInvitationSubtitle",
    TesterInvitationBadge: "TesterInvitationBadge",
    TesterInvitationTitle: "TesterInvitationTitle",
    TesterInvitationDescription: "TesterInvitationDescription",
    TesterInvitationIncludesTitle: "TesterInvitationIncludesTitle",
    TesterInvitationFeatureClassroomWorkspace: "TesterInvitationFeatureClassroomWorkspace",
    TesterInvitationFeatureQuizzesAssignments: "TesterInvitationFeatureQuizzesAssignments",
    TesterInvitationFeatureStudentProgress: "TesterInvitationFeatureStudentProgress",
    TesterInvitationFeatureFileUploads: "TesterInvitationFeatureFileUploads",
    TesterInvitationFeatureFeedback: "TesterInvitationFeatureFeedback",
    TesterInvitationDurationNotice: "TesterInvitationDurationNotice",
    TesterInvitationPlansNotice: "TesterInvitationPlansNotice",
    TesterInvitationCta: "TesterInvitationCta",
    TesterInvitationInfoText: "TesterInvitationInfoText",
    TesterRequestPageTitle: "TesterRequestPageTitle",
    TesterRequestHeading: "TesterRequestHeading",
    TesterRequestIntro: "TesterRequestIntro",
    TesterRequestLoadingStatus: "TesterRequestLoadingStatus",
    TesterRequestMessageLabel: "TesterRequestMessageLabel",
    TesterRequestMessagePlaceholder: "TesterRequestMessagePlaceholder",
    TesterRequestDefaultMessage: "TesterRequestDefaultMessage",
    TesterRequestSending: "TesterRequestSending",
    TesterRequestSend: "TesterRequestSend",
    TesterRequestBackToPlans: "TesterRequestBackToPlans",
    TesterRequestErrorAlreadySubmitted: "TesterRequestErrorAlreadySubmitted",
    TesterRequestErrorMessageRequired: "TesterRequestErrorMessageRequired",
    TesterRequestErrorLoadStatus: "TesterRequestErrorLoadStatus",
    TesterRequestErrorSubmit: "TesterRequestErrorSubmit",
    TesterRequestSuccessSubmitted: "TesterRequestSuccessSubmitted",
    TesterRequestStatusPending: "TesterRequestStatusPending",
    TesterRequestStatusReviewed: "TesterRequestStatusReviewed",
    TesterRequestStatusActive: "TesterRequestStatusActive",
  },
  TC: {
    Page: "TermsAndConditions",
    Title: "Title",
    PrivacyPolicy: "PrivacyPolicy",
    CookiesPolicy: "CookiesPolicy",
    UseCookies: "UseCookies",
    UseCookiesTo: "UseCookiesTo",
    UseCookiesPart1: "UseCookiesPart1",
    UseCookiesPart2: "UseCookiesPart2",
    UseCookiesPart3: "UseCookiesPart3",
    RightsTitle: "RightsTitle",
    RightsPart1: "RightsPart1",
    RightsPart2: "RightsPart2",
    RightsPart3: "RightsPart3",
    DataRetentionTitle: "DataRetentionTitle",
    DataRetentionPart1: "DataRetentionPart1",
    PrivacyPolicyAgreement: "PrivacyPolicyAgreement",
    PersonalData: "PersonalData",
    PersonalDataTitle: "PersonalDataTitle",
    PersonalDataPart1: "PersonalDataPart1",
    PersonalDataPart1b: "PersonalDataPart1b",
    PersonalDataPart2: "PersonalDataPart2",
    PersonalDataPart2b: "PersonalDataPart2b",
    PersonalDataPart3: "PersonalDataPart3",
    PersonalDataPart3b: "PersonalDataPart3b",
    PersonalDataPart4: "PersonalDataPart4",
    PersonalDataPart4b: "PersonalDataPart4b",
    UseOfPersonalData: "UseOfPersonalData",
    UseOfPersonalDataTitle: "UseOfPersonalDataTitle",
    UseOfPersonalDataPart1: "UseOfPersonalDataPart1",
    UseOfPersonalDataPart2: "UseOfPersonalDataPart2",
    UseOfPersonalDataPart3: "UseOfPersonalDataPart3",
    UseOfPersonalDataPart4: "UseOfPersonalDataPart4",
    UseOfPersonalDataPart5: "UseOfPersonalDataPart5",
    UseOfPersonalDataPart6: "UseOfPersonalDataPart6",
    SecureData: "SecureData",
    SecureDataTitle: "SecureDataTitle",
    SecureDataPart1: "SecureDataPart1",
    SecureDataPart2: "SecureDataPart2",
    SecureDataPart3: "SecureDataPart3",
    SecureDataPart4: "SecureDataPart4",
    SecureDataPart5: "SecureDataPart5",
    SecureDataPart6: "SecureDataPart6",
    SecureDataPart7: "SecureDataPart7",
    TCAgreement: "TCAgreement",
    ContactUs: "ContactUs",
    TCAgreementTitle: "TCAgreementTitle",
    TCAgreementPart1: "TCAgreementPart1",
    TCAgreementPart2: "TCAgreementPart2",
    TCAgreementPart3: "TCAgreementPart3",
    TCAgreementPart4: "TCAgreementPart4",
    TCAgreementPart5: "TCAgreementPart5",
    UsingMemocipe: "UsingMemocipe",
    UsingMemocipeTitle: "UsingMemocipeTitle",
    UsingMemocipePart1: "UsingMemocipePart1",
    UsingMemocipePart2: "UsingMemocipePart2",
    UsingMemocipePart3: "UsingMemocipePart3",
    UsingMemocipePart4: "UsingMemocipePart4",
    UsingMemocipePart4b: "UsingMemocipePart4b",
    UsingMemocipePart4c: "UsingMemocipePart4c",
    UsingMemocipePart5: "UsingMemocipePart5",
    SubmittingInfoTitle: "SubmittingInfoTitle",
    SubmittingInfoPart1: "SubmittingInfoPart1",
    SubmittingInfoPart2: "SubmittingInfoPart2",
    AccuracyOfInformationTitle: "AccuracyOfInformationTitle",
    AccuracyOfInformationPart1: "AccuracyOfInformationPart1",
    AccuracyOfInformationPart2: "AccuracyOfInformationPart2",
    AccuracyOfInformationPart3: "AccuracyOfInformationPart3",
    AccuracyOfInformationPart4: "AccuracyOfInformationPart4",
    ThirdPartyLinksTitle: "ThirdPartyLinksTitle",
    ThirdPartyLinksPart1: "ThirdPartyLinksPart1",
    LiabilityTitle: "LiabilityTitle",
    LiabilityPart1: "LiabilityPart1",
    EventsTitle: "EventsTitle",
    EventsPart1: "EventsPart1",
    UpdatesTitle: "UpdatesTitle",
    UpdatesPart1: "UpdatesPart1",
    DisputesTitle: "DisputesTitle",
    DisputesPart1: "DisputesPart1",
    DisputesPart2: "DisputesPart2",
    DisputesPart3: "DisputesPart3",
    PrincingTitle: "PrincingTitle",
    PrincingPart1: "PrincingPart1",
    PrincingPart2: "PrincingPart2",
    PrincingPart3: "PrincingPart3",
    Payment: "Payment",
    PaymentTitle: "PaymentTitle",
    Visa: "Visa",
    Mastercard: "Mastercard",
    AmericanExpress: "AmericanExpress",
  },
  Transfer: {
    Page: "Transfer",
    Title: "Title",
    Send: "Send",
    Destination: "Destination",
    ConfirmationMsg: "ConfirmationMsg",
    ChooseContact: "ChooseContact",
    TransferUnavailable: "TransferUnavailable",
    TransferWindowExpired: "TransferWindowExpired",
  },
  Contact: {
    Page: "Contact",
    Title: "Title",
    Name: "Name",
    NamePlaceholder: "NamePlaceholder",
    Email: "Email",
    EmailPlaceholder: "EmailPlaceholder",
    Message: "Message",
    MessagePlaceholder: "MessagePlaceholder",
    Send: "Send",
    MessageSent: "MessageSent",
  },
  CreateQuiz: {
    Page: "CreateQuiz",
    Title: "Title",
    AddChapter: "AddChapter",
    AddQuestion: "AddQuestion",
    AddAnswer: "AddAnswer",
    QuestionPlaceholder: "QuestionPlaceholder",
    AnswerPlaceholder: "AnswerPlaceholder",
    CorrectAnswer: "CorrectAnswer",
    AddChapterBtn: "AddChapterBtn",
    AddQuestionBtn: "AddQuestionBtn",
    AddAnswerBtn: "AddAnswerBtn",
    CreateQuiz: "Create Quiz",
    Description: "Description",
  },
  Tutors: {
    Classroom: {
      Page: "Tutors.Classroom",
      PageTitle: "PageTitle",
      Edit: "Edit",
      Add: "Add",
      AddQuestions: "AddQuestions",
      OrderLessons: "OrderLessons",
      OrderContents: "OrderContents",
      OrderLessonsHelpTitle: "OrderLessonsHelpTitle",
      OrderLessonsHelpDescription: "OrderLessonsHelpDescription",
      OrderContentsHelpTitle: "OrderContentsHelpTitle",
      OrderContentsHelpDescription: "OrderContentsHelpDescription",
      OrderQuestions: "OrderQuestions",
      PublishLesson: "PublishLesson",
      UnpublishLesson: "UnpublishLesson",
      Published: "Published",
      Draft: "Draft",
      Delete: "Delete",
      ClassroomsPageTitle: "ClassroomsPageTitle",
      CreateChapterTitle: "CreateChapterTitle",
      QuizTitle: "QuizTitle",
      QuizSubTitle: "QuizSubTitle",
      QuestionsTitle: "QuestionsTitle",
      ContentPageTitle: "ContentPageTitle",
      Chapters: "Chapters",
      Subtitle: "Subtitle",
      ContentSubtitle: "ContentSubtitle",
      Title: "Title",
      TitlePlaceholder: "TitlePlaceholder",
      Description: "Description",
      DescriptionPlaceholder: "DescriptionPlaceholder",
      ForChildrenUnder12Label: "ForChildrenUnder12Label",
      ForChildrenUnder12Description: "ForChildrenUnder12Description",
      CharactersLeft: "CharactersLeft",
      JoinMode: "JoinMode",
      JoinModeInviteOnly: "JoinModeInviteOnly",
      JoinModeInviteOnlyHelper: "JoinModeInviteOnlyHelper",
      JoinModeRequestToJoin: "JoinModeRequestToJoin",
      JoinModeRequestToJoinHelper: "JoinModeRequestToJoinHelper",
      IsClassroomDiscoverable: "IsClassroomDiscoverable",
      IsClassroomDiscoverableHelper: "IsClassroomDiscoverableHelper",
      RequiresCredit: "RequiresCredit",
      RequiresCreditHelper: "RequiresCreditHelper",
      DiscoverabilityEnabled: "DiscoverabilityEnabled",
      DiscoverabilityDisabled: "DiscoverabilityDisabled",
      InviteStudentsTitle: "InviteStudentsTitle",
      InviteStudentsPageTitle: "InviteStudentsPageTitle",
      InviteStudentsSubtitle: "InviteStudentsSubtitle",
      InviteStudentsHelper: "InviteStudentsHelper",
      NoContactsAvailableForInvite: "NoContactsAvailableForInvite",
      InviteStudent: "InviteStudent",
      InvitationPending: "InvitationPending",
      InvitationSent: "InvitationSent",
      JoinCodeTitle: "JoinCodeTitle",
      JoinCodeSubtitle: "JoinCodeSubtitle",
      QuizJoinCodeTitle: "QuizJoinCodeTitle",
      QuizJoinCodeSubtitle: "QuizJoinCodeSubtitle",
      QuizJoinCodeMissing: "QuizJoinCodeMissing",
      QuizJoinCodeClassroomWarning: "QuizJoinCodeClassroomWarning",
      JoinCodeMissing: "JoinCodeMissing",
      JoinCodeGenerate: "JoinCodeGenerate",
      JoinCodeGenerating: "JoinCodeGenerating",
      JoinCodeRegenerate: "JoinCodeRegenerate",
      JoinCodeRegenerating: "JoinCodeRegenerating",
      JoinCodeCopy: "JoinCodeCopy",
      JoinCodeCopied: "JoinCodeCopied",
      JoinCodeAvailableUntil: "JoinCodeAvailableUntil",
      JoinCodeMissingCourseId: "JoinCodeMissingCourseId",
      JoinCodeForbidden: "JoinCodeForbidden",
      JoinCodeLoadError: "JoinCodeLoadError",
      JoinCodeCreateError: "JoinCodeCreateError",
      QuizJoinCodeMissingQuizId: "QuizJoinCodeMissingQuizId",
      QuizJoinCodeForbidden: "QuizJoinCodeForbidden",
      QuizJoinCodeLoadError: "QuizJoinCodeLoadError",
      QuizJoinCodeCreateError: "QuizJoinCodeCreateError",
      QuotaOverviewTitle: "QuotaOverviewTitle",
      QuotaOverviewClassroomDescription: "QuotaOverviewClassroomDescription",
      QuotaOverviewQuizDescription: "QuotaOverviewQuizDescription",
      NextMeetingsTitle: "NextMeetingsTitle",
      NextMeetingsDescription: "NextMeetingsDescription",
      NextMeetingsEmpty: "NextMeetingsEmpty",
      NextMeetingsJoinAction: "NextMeetingsJoinAction",
      QuotaStatusCached: "QuotaStatusCached",
      QuotaStatusLive: "QuotaStatusLive",
      QuotaUnlimited: "QuotaUnlimited",
      Url: "Url",
      UrlPlaceholder: "UrlPlaceholder",
      Cancel: "Cancel",
      Next: "Next",
      Error: "Error",
      NewChapter: "NewChapter",
      NewLesson: "NewLesson",
      NewContent: "NewContent",
      Text: "Text",
      TextManualValidation: "TextManualValidation",
      ChessPgnQuestion: "ChessPgnQuestion",
      ChessPgnInfo: "ChessPgnInfo",
      ChessPgnDefaultQuestion: "ChessPgnDefaultQuestion",
      TextAutoValidation: "TextAutoValidation",
      TextPlaceholder: "TextPlaceholder",
      Library: "Library",
      LibraryPlaceholder: "LibraryPlaceholder",
      ContentTypeLibrary: "ContentTypeLibrary",
      Maths: "Maths",
      MathsPlaceholder: "MathsPlaceholder",
      Viewer: "Viewer",
      MathsFormulaExample: "MathsFormulaExample",
      MathsQuestionInfo: "MathsQuestionInfo",
      MathsQuestionPreview: "MathsQuestionPreview",
      MathsQuestionPreviewEmpty: "MathsQuestionPreviewEmpty",
      MathsExpectedAnswerPreview: "MathsExpectedAnswerPreview",
      MathsExpectedAnswerPreviewEmpty: "MathsExpectedAnswerPreviewEmpty",
      MathsPreviewInvalid: "MathsPreviewInvalid",
      Search: "Search",
      SearchPlaceholder: "SearchPlaceholder",
      SearchResults: "SearchResults",
      SearchResultsExistingContent: "SearchResultsExistingContent",
      SearchResultsExistingContentSummary: "SearchResultsExistingContentSummary",
      SearchResultsExistingContentEmpty: "SearchResultsExistingContentEmpty",
      NoResults: "NoResults",
      FileLibraryAssetsResults: "FileLibraryAssetsResults",
      FileLibraryAssetsResultsSummary: "FileLibraryAssetsResultsSummary",
      FileLibraryAssetsResultsEmpty: "FileLibraryAssetsResultsEmpty",
      FileLibraryAttachToLesson: "FileLibraryAttachToLesson",
      FileLibraryLoadMore: "FileLibraryLoadMore",
      FileLibraryLoadingMore: "FileLibraryLoadingMore",
      AddQuestionTitle: "AddQuestionTitle",
      EditQuestionTitle: "EditQuestionTitle",
      Question: "Question",
      QuestionType: "QuestionType",
      QuestionPlaceholder: "QuestionPlaceholder",
      ChessPgn: "ChessPgn",
      ChessPgnPlaceholder: "ChessPgnPlaceholder",
      ChessPgnHelp: "ChessPgnHelp",
      ChessPgnBoardPreview: "ChessPgnBoardPreview",
      ChessPgnInvalid: "ChessPgnInvalid",
      ChessPgnEmpty: "ChessPgnEmpty",
      ChessPgnEvaluation: "ChessPgnEvaluation",
      ChessPgnEvaluationOn: "ChessPgnEvaluationOn",
      ChessPgnEvaluationOff: "ChessPgnEvaluationOff",
      ChessPgnEvaluationLoading: "ChessPgnEvaluationLoading",
      ChessPgnEvaluationError: "ChessPgnEvaluationError",
      ChessPgnEvaluationScore: "ChessPgnEvaluationScore",
      ChessPgnEvaluationDepth: "ChessPgnEvaluationDepth",
      ChessPgnEvaluationLines: "ChessPgnEvaluationLines",
      ChessPgnEvaluationLine: "ChessPgnEvaluationLine",
      ChessPgnEvaluationConfiguredDepth: "ChessPgnEvaluationConfiguredDepth",
      ChessPgnOptionCountLabel: "ChessPgnOptionCountLabel",
      ChessPgnOptionsLabel: "ChessPgnOptionsLabel",
      ChessPgnEngineOptionsWaiting: "ChessPgnEngineOptionsWaiting",
      ChessPgnOptionPlaceholder: "ChessPgnOptionPlaceholder",
      ChessPgnOptionsValidation: "ChessPgnOptionsValidation",
      QuestionWorkflowStepQuestion: "QuestionWorkflowStepQuestion",
      QuestionWorkflowStepImage: "QuestionWorkflowStepImage",
      QuestionWorkflowStepAnswers: "QuestionWorkflowStepAnswers",
      QuestionWorkflowBack: "QuestionWorkflowBack",
      QuestionWorkflowNext: "QuestionWorkflowNext",
      AnswerExplained: "AnswerExplained",
      AnswerExplainedPlaceholder: "AnswerExplainedPlaceholder",
      AnswerExplainedInfo: "AnswerExplainedInfo",
      QuestionImageLabel: "QuestionImageLabel",
      QuestionImageHelp: "QuestionImageHelp",
      QuestionImageLockedBadge: "QuestionImageLockedBadge",
      QuestionImageLockedDescription: "QuestionImageLockedDescription",
      QuestionImageUpgradeAction: "QuestionImageUpgradeAction",
      QuestionImageChooseFromLibrary: "QuestionImageChooseFromLibrary",
      QuestionImageHideLibrary: "QuestionImageHideLibrary",
      QuestionImageCurrentLabel: "QuestionImageCurrentLabel",
      QuestionImagePreviewAlt: "QuestionImagePreviewAlt",
      QuestionImageRemoveAction: "QuestionImageRemoveAction",
      QuestionImageSearchPlaceholder: "QuestionImageSearchPlaceholder",
      QuestionImageLibraryLoading: "QuestionImageLibraryLoading",
      QuestionImageLibraryEmpty: "QuestionImageLibraryEmpty",
      QuestionImageLibraryLoadError: "QuestionImageLibraryLoadError",
      QuestionImageSelectAction: "QuestionImageSelectAction",
      QuestionImageSelectedAsset: "QuestionImageSelectedAsset",
      QuestionAudioLabel: "QuestionAudioLabel",
      QuestionAudioHelp: "QuestionAudioHelp",
      QuestionAudioLockedBadge: "QuestionAudioLockedBadge",
      QuestionAudioLockedDescription: "QuestionAudioLockedDescription",
      QuestionAudioUpgradeAction: "QuestionAudioUpgradeAction",
      QuestionAudioEnableAction: "QuestionAudioEnableAction",
      QuestionAudioShowTextAction: "QuestionAudioShowTextAction",
      QuestionAudioShowTextHelp: "QuestionAudioShowTextHelp",
      QuestionAudioStatusLabel: "QuestionAudioStatusLabel",
      QuestionAudioStatusWaitingForSave: "QuestionAudioStatusWaitingForSave",
      QuestionAudioStatusUnknown: "QuestionAudioStatusUnknown",
      QuestionAudioDurationLabel: "QuestionAudioDurationLabel",
      QuestionAudioPlaybackUnsupported: "QuestionAudioPlaybackUnsupported",
      QuestionAudioSaveHint: "QuestionAudioSaveHint",
      TextQuestionManualVal: "TextQuestionManualVal",
      TextQuestionAutoVal: "TextQuestionAutoVal",
      ExpectedAnswer: "ExpectedAnswer",
      ExpectedAnswerPlaceholder: "ExpectedAnswerPlaceholder",
      TextWithAutoValidation: "TextWithAutoValidation",
      AutomaticValidation: "AutomaticValidation",
      Yes: "Yes",
      No: "No",
      SuccessUpdated: "SuccessUpdated",
      Duplicate: "Duplicate",
      Save: "Save",
      Options: "Options",
      QuizType: "QuizType",
      Standard: "Standard",
      SpacedRepetition: "Flashcards",
      Flashcards: "Flashcards",
      Repeatable: "Repeatable",
      ReviewModeHint: "ReviewModeHint",
      RepeatableQuizQuotaHint: "RepeatableQuizQuotaHint",
      RepeatableQuizQuotaUsage: "RepeatableQuizQuotaUsage",
      RepeatableQuizQuotaExceeded: "RepeatableQuizQuotaExceeded",
      ShowInfo: "ShowInfo",
      PlayAndLearn: "PlayAndLearn",
      StandardWithAutoValidation: "StandardWithAutoValidation",
      MultipleOption: "MultipleOption",
      SingleOption: "SingleOption",
      TrueFalse: "TrueFalse",
      TrueFalseCorrectOptionHelp: "TrueFalseCorrectOptionHelp",
      Option: "Option",
      AddOption: "AddOption",
      IsCorrect: "IsCorrect",
      AtLeastTwoOptions: "AtLeastTwoOptions",
      InsertDescriptionForAllOptions: "InsertDescriptionForAllOptions",
      AtLeastOneCorrectOption: "AtLeastOneCorrectOption",
      File: "File",
      CompletionSentence: "CompletionSentence",
      CompletionSentenceInfo: "CompletionSentenceInfo",
      CompletionSentenceLanguageInfo: "CompletionSentenceLanguageInfo",
      CompletionSentenceDefaultQuestion: "CompletionSentenceDefaultQuestion",
      TestYourself: "TestYourself",
      Answers: "Answers",
      InvalidFile: "InvalidFile",
      MustHaveExactlyOneCorrectAnswer: "MustHaveExactlyOneCorrectAnswer",
      MustHaveAtLeastTwoAnswers: "MustHaveAtLeastTwoAnswers",
      MustHaveAtLeastTwoBlankSpaces: "MustHaveAtLeastTwoBlankSpaces",
      MustHaveAtLeastOneCorrectAnswer: "MustHaveAtLeastOneCorrectAnswer",
      MustHaveOneAnswer: "MustHaveOneAnswer",
      ShouldNotHaveAnyAnswer: "ShouldNotHaveAnyAnswer",
      InvalidNumberOfAnswers: "InvalidNumberOfAnswers",
      UnknownQuestionType: "UnknownQuestionType",
      Leaderboard: "Leaderboard",
      Country: "Country",
      StudentName: "StudentName",
      Score: "Score",
      Date: "Date",
      NoData: "NoData",
      Create: "Create",
      NewClassroom: "NewClassroom",
      CreateQuiz: "CreateQuiz",
      TeachingWorkspaceTitle: "TeachingWorkspaceTitle",
      QuizzesWorkspaceTitle: "QuizzesWorkspaceTitle",
      ClassroomsTabLabel: "ClassroomsTabLabel",
      QuizzesTabLabel: "QuizzesTabLabel",
      ClassroomsTabDescription: "ClassroomsTabDescription",
      QuizzesTabDescription: "QuizzesTabDescription",
      NoQuizzesYet: "NoQuizzesYet",
      TutorWorkspace: "TutorWorkspace",
      ClassroomLabel: "ClassroomLabel",
      ClassroomEmptyDescription: "ClassroomEmptyDescription",
      AllClassrooms: "AllClassrooms",
      LessonsSummary: "LessonsSummary",
      QuotaContentItems: "QuotaContentItems",
      QuotaStudents: "QuotaStudents",
      QuotaCoTeachers: "QuotaCoTeachers",
      QuotaAssignedStudents: "QuotaAssignedStudents",
      QuotaDirectAssignedStudents: "QuotaDirectAssignedStudents",
      QuotaClassroomAttachedStudents: "QuotaClassroomAttachedStudents",
      QuotaTotalAssignedStudents: "QuotaTotalAssignedStudents",
      QuotaPublishedQuizzes: "QuotaPublishedQuizzes",
      QuotaQuizCreationsThisMonth: "QuotaQuizCreationsThisMonth",
      FileLibraryTitle: "FileLibraryTitle",
      FileLibraryDisabledHint: "FileLibraryDisabledHint",
      FileLibraryHeading: "FileLibraryHeading",
      FileLibraryDescription: "FileLibraryDescription",
      FileLibraryUsedSpace: "FileLibraryUsedSpace",
      FileLibraryStorageUsageWithLimit: "FileLibraryStorageUsageWithLimit",
      FileLibraryActiveFilesCount: "FileLibraryActiveFilesCount",
      FileLibraryChooseFile: "FileLibraryChooseFile",
      FileLibraryDescriptionPlaceholder: "FileLibraryDescriptionPlaceholder",
      FileLibraryTags: "FileLibraryTags",
      FileLibraryTagInputPlaceholder: "FileLibraryTagInputPlaceholder",
      FileLibraryAddTag: "FileLibraryAddTag",
      FileLibraryTagHelper: "FileLibraryTagHelper",
      FileLibraryUploading: "FileLibraryUploading",
      FileLibraryUploadAction: "FileLibraryUploadAction",
      FileLibraryAllowedFormats: "FileLibraryAllowedFormats",
      FileLibraryStoredAssets: "FileLibraryStoredAssets",
      FileLibraryStoredAssetsSummary: "FileLibraryStoredAssetsSummary",
      FileLibraryEmpty: "FileLibraryEmpty",
      FileLibraryStatus: "FileLibraryStatus",
      FileLibraryDeleteError: "FileLibraryDeleteError",
      FileLibraryLoadError: "FileLibraryLoadError",
      FileLibraryChooseFileError: "FileLibraryChooseFileError",
      FileLibraryCloudflareUploadError: "FileLibraryCloudflareUploadError",
      FileLibraryUploadSuccess: "FileLibraryUploadSuccess",
      FileLibraryUploadError: "FileLibraryUploadError",
      FileLibraryFolders: "FileLibraryFolders",
      FileLibraryAllFiles: "FileLibraryAllFiles",
      FileLibraryUnfiled: "FileLibraryUnfiled",
      FileLibraryNewFolder: "FileLibraryNewFolder",
      FileLibraryFolderNamePrompt: "FileLibraryFolderNamePrompt",
      FileLibraryRenameFolderPrompt: "FileLibraryRenameFolderPrompt",
      FileLibraryCreateFolderError: "FileLibraryCreateFolderError",
      FileLibraryRenameFolderError: "FileLibraryRenameFolderError",
      FileLibraryDeleteFolderConfirm: "FileLibraryDeleteFolderConfirm",
      FileLibraryDeleteFolderError: "FileLibraryDeleteFolderError",
      FileLibraryMoveToFolder: "FileLibraryMoveToFolder",
      FileLibraryMoveError: "FileLibraryMoveError",
      FileLibraryRootFolder: "FileLibraryRootFolder",
      FileLibraryUploadDestination: "FileLibraryUploadDestination",
      FileLibraryFolderEmpty: "FileLibraryFolderEmpty",
      FileLibraryRootOnlyHint: "FileLibraryRootOnlyHint",
      StudentsPageTitle: "StudentsPageTitle",
      StudentsWorkspaceTitle: "StudentsWorkspaceTitle",
      StudentsWorkspaceDescription: "StudentsWorkspaceDescription",
      StudentsSearchPlaceholder: "StudentsSearchPlaceholder",
      StudentsSearchEmpty: "StudentsSearchEmpty",
      StudentsRegisteredCount: "StudentsRegisteredCount",
      StudentsRosterTitle: "StudentsRosterTitle",
      StudentsRosterSubtitle: "StudentsRosterSubtitle",
      StudentsOpenProfileSoon: "StudentsOpenProfileSoon",
      StudentsInsightsLiveDescription: "StudentsInsightsLiveDescription",
      StudentsAnalyticsFreePlanBadge: "StudentsAnalyticsFreePlanBadge",
      StudentsAnalyticsFreePlanTitle: "StudentsAnalyticsFreePlanTitle",
      StudentsAnalyticsFreePlanDescription: "StudentsAnalyticsFreePlanDescription",
      StudentsAnalyticsFreePlanHint: "StudentsAnalyticsFreePlanHint",
      StudentsAnalyticsUpgradeAction: "StudentsAnalyticsUpgradeAction",
      StudentsInsightsSummarySubmittedThisWeek: "StudentsInsightsSummarySubmittedThisWeek",
      StudentsInsightsSummaryCompletion: "StudentsInsightsSummaryCompletion",
      StudentsInsightsSummaryScore: "StudentsInsightsSummaryScore",
      StudentsInsightsSummaryAtRisk: "StudentsInsightsSummaryAtRisk",
      StudentsInsightsTableTitle: "StudentsInsightsTableTitle",
      StudentsInsightsFreePlanDescription: "StudentsInsightsFreePlanDescription",
      StudentsInsightsFilterAll: "StudentsInsightsFilterAll",
      StudentsInsightsFilterAtRisk: "StudentsInsightsFilterAtRisk",
      StudentsInsightsFilterNeedsAttention: "StudentsInsightsFilterNeedsAttention",
      StudentsInsightsFilterOnTrack: "StudentsInsightsFilterOnTrack",
      StudentsInsightsColumnStudent: "StudentsInsightsColumnStudent",
      StudentsInsightsColumnAvailability: "StudentsInsightsColumnAvailability",
      StudentsInsightsColumnExpected: "StudentsInsightsColumnExpected",
      StudentsInsightsColumnSubmitted: "StudentsInsightsColumnSubmitted",
      StudentsInsightsColumnCompletion: "StudentsInsightsColumnCompletion",
      StudentsInsightsColumnQuizScore: "StudentsInsightsColumnQuizScore",
      StudentsInsightsColumnLastActive: "StudentsInsightsColumnLastActive",
      StudentsInsightsColumnRisk: "StudentsInsightsColumnRisk",
      StudentsInsightsColumnTrend: "StudentsInsightsColumnTrend",
      StudentsInsightsColumnStatus: "StudentsInsightsColumnStatus",
      StudentsInsightsLockedValue: "StudentsInsightsLockedValue",
      StudentsInsightsAnalyticsLocked: "StudentsInsightsAnalyticsLocked",
      StudentsInsightsAnalyticsLockedHint: "StudentsInsightsAnalyticsLockedHint",
      StudentsInsightsStatusNeedsAttention: "StudentsInsightsStatusNeedsAttention",
      StudentsInsightsStatusWatch: "StudentsInsightsStatusWatch",
      StudentsInsightsStatusOnTrack: "StudentsInsightsStatusOnTrack",
      StudentsInsightsRiskHigh: "StudentsInsightsRiskHigh",
      StudentsInsightsRiskMedium: "StudentsInsightsRiskMedium",
      StudentsInsightsRiskLow: "StudentsInsightsRiskLow",
      StudentsInsightsTrendUp: "StudentsInsightsTrendUp",
      StudentsInsightsTrendFlat: "StudentsInsightsTrendFlat",
      StudentsInsightsTrendDown: "StudentsInsightsTrendDown",
      StudentsInsightsLastActiveToday: "StudentsInsightsLastActiveToday",
      StudentsInsightsLastActiveDays: "StudentsInsightsLastActiveDays",
      StudentsInsightsRowAction: "StudentsInsightsRowAction",
      StudentsInsightsExplanationLabel: "StudentsInsightsExplanationLabel",
      StudentsInsightsExplanationDismiss: "StudentsInsightsExplanationDismiss",
      StudentsInsightsExplanationRiskTitle: "StudentsInsightsExplanationRiskTitle",
      StudentsInsightsExplanationRiskDescription: "StudentsInsightsExplanationRiskDescription",
      StudentsInsightsExplanationRiskHigh: "StudentsInsightsExplanationRiskHigh",
      StudentsInsightsExplanationRiskMedium: "StudentsInsightsExplanationRiskMedium",
      StudentsInsightsExplanationRiskLow: "StudentsInsightsExplanationRiskLow",
      StudentsInsightsExplanationTrendTitle: "StudentsInsightsExplanationTrendTitle",
      StudentsInsightsExplanationTrendDescription: "StudentsInsightsExplanationTrendDescription",
      StudentsInsightsExplanationTrendUp: "StudentsInsightsExplanationTrendUp",
      StudentsInsightsExplanationTrendFlat: "StudentsInsightsExplanationTrendFlat",
      StudentsInsightsExplanationTrendDown: "StudentsInsightsExplanationTrendDown",
      StudentsInsightsExplanationStatusTitle: "StudentsInsightsExplanationStatusTitle",
      StudentsInsightsExplanationStatusDescription: "StudentsInsightsExplanationStatusDescription",
      StudentsInsightsExplanationStatusNeedsAttention: "StudentsInsightsExplanationStatusNeedsAttention",
      StudentsInsightsExplanationStatusWatch: "StudentsInsightsExplanationStatusWatch",
      StudentsInsightsExplanationStatusOnTrack: "StudentsInsightsExplanationStatusOnTrack",
      CreditsSectionTitle: "CreditsSectionTitle",
      CreditsSectionDescription: "CreditsSectionDescription",
      CreditsAvailable: "CreditsAvailable",
      CreditsGranted: "CreditsGranted",
      CreditsUsed: "CreditsUsed",
      CreditsSummaryLowStudents: "CreditsSummaryLowStudents",
      CreditsHistoryTitle: "CreditsHistoryTitle",
      CreditsHistoryEmpty: "CreditsHistoryEmpty",
      CreditsUpdate: "CreditsUpdate",
      CreditsAmountPlaceholder: "CreditsAmountPlaceholder",
      CreditsNotesPlaceholder: "CreditsNotesPlaceholder",
      CreditsApply: "CreditsApply",
      CreditsViewHistory: "CreditsViewHistory",
      CreditsHideHistory: "CreditsHideHistory",
      CreditsLowWarning: "CreditsLowWarning",
      CreditsCoverageEnoughNextBookings: "CreditsCoverageEnoughNextBookings",
      CreditsCoverageEnoughAll: "CreditsCoverageEnoughAll",
      CreditsCoverageNoUpcoming: "CreditsCoverageNoUpcoming",
      CreditsNotEnabled: "CreditsNotEnabled",
      CreditsLoading: "CreditsLoading",
      CreditsStudentDescription: "CreditsStudentDescription",
      CreditsUpcomingBookings: "CreditsUpcomingBookings",
      CreditsEntryPositive: "CreditsEntryPositive",
      CreditsEntryNegative: "CreditsEntryNegative",
      CreditsNoNotes: "CreditsNoNotes",
      CreditsHistoryCardDescription: "CreditsHistoryCardDescription",
      CreditsViewHistoryPageAction: "CreditsViewHistoryPageAction",
      CreditsHistoryPageDescription: "CreditsHistoryPageDescription",
      CreditsUsageSummaryTitle: "CreditsUsageSummaryTitle",
      CreditsTutorHistoryPageDescription: "CreditsTutorHistoryPageDescription",
      CreditsViewClassroomHistoryAction: "CreditsViewClassroomHistoryAction",
      CreditsAllStudentsOption: "CreditsAllStudentsOption",
      CreditsDisabledTitle: "CreditsDisabledTitle",
      CreditsActivateDescription: "CreditsActivateDescription",
      CreditsActivateAction: "CreditsActivateAction",
      CreditsSummaryDescription: "CreditsSummaryDescription",
      CreditsSummaryWarning: "CreditsSummaryWarning",
      CurriculumTitle: "CurriculumTitle",
      CurriculumSubtitle: "CurriculumSubtitle",
      LessonCountSingular: "LessonCountSingular",
      LessonCountPlural: "LessonCountPlural",
      ClassroomResourcesTitle: "ClassroomResourcesTitle",
      ClassroomResourcesSubtitle: "ClassroomResourcesSubtitle",
      LessonLabel: "LessonLabel",
      LessonCardEmptyDescription: "LessonCardEmptyDescription",
      ContentCountSingular: "ContentCountSingular",
      ContentCountPlural: "ContentCountPlural",
      AddContent: "AddContent",
      ViewLessonContents: "ViewLessonContents",
      DeleteClassroomConfirm: "DeleteClassroomConfirm",
      DeleteClassroomError: "DeleteClassroomError",
      DeleteLessonConfirm: "DeleteLessonConfirm",
      DeleteLessonError: "DeleteLessonError",
      DeleteContentConfirm: "DeleteContentConfirm",
      DeleteContentError: "DeleteContentError",
      DeleteContentSuccess: "DeleteContentSuccess",
      NoLessons: "NoLessons",
      LessonWorkspace: "LessonWorkspace",
      LessonEmptyDescription: "LessonEmptyDescription",
      ResourcesSummary: "ResourcesSummary",
      AttachedQuizzesSummary: "AttachedQuizzesSummary",
      TotalItemsSummary: "TotalItemsSummary",
      BackToClassroom: "BackToClassroom",
      LessonResourcesTitle: "LessonResourcesTitle",
      LessonResourcesSubtitle: "LessonResourcesSubtitle",
      AttachedQuizzesTitle: "AttachedQuizzesTitle",
      AttachedQuizzesSubtitle: "AttachedQuizzesSubtitle",
      ClassroomQuizActivityPageTitle: "ClassroomQuizActivityPageTitle",
      ClassroomQuizActivityPageDescription: "ClassroomQuizActivityPageDescription",
      ClassroomQuizActivityLessonLabel: "ClassroomQuizActivityLessonLabel",
      ClassroomQuizActivityTotal: "ClassroomQuizActivityTotal",
      ClassroomQuizActivityAssigned: "ClassroomQuizActivityAssigned",
      ClassroomQuizActivityDue: "ClassroomQuizActivityDue",
      ClassroomQuizActivityMissed: "ClassroomQuizActivityMissed",
      ClassroomQuizActivitySubmitted: "ClassroomQuizActivitySubmitted",
      ClassroomQuizActivityPending: "ClassroomQuizActivityPending",
      ClassroomQuizActivityEmpty: "ClassroomQuizActivityEmpty",
      ClassroomQuizActivityOpenPageAction: "ClassroomQuizActivityOpenPageAction",
      ClassroomQuizActivityOpenLessonAction: "ClassroomQuizActivityOpenLessonAction",
      ClassroomQuizActivityStatusAssigned: "ClassroomQuizActivityStatusAssigned",
      ClassroomQuizActivityStatusDue: "ClassroomQuizActivityStatusDue",
      ClassroomQuizActivityStatusMissed: "ClassroomQuizActivityStatusMissed",
      ClassroomQuizActivityStatusSubmitted: "ClassroomQuizActivityStatusSubmitted",
      ClassroomQuizActivityStatusPending: "ClassroomQuizActivityStatusPending",
      ClassroomQuizActivityBestScore: "ClassroomQuizActivityBestScore",
      ClassroomQuizActivityLatestScore: "ClassroomQuizActivityLatestScore",
      ClassroomQuizActivityNeverSubmitted: "ClassroomQuizActivityNeverSubmitted",
      ClassroomQuizActivityNoDescription: "ClassroomQuizActivityNoDescription",
      ClassroomQuizActivityStartAction: "ClassroomQuizActivityStartAction",
      ClassroomQuizActivityRetryAction: "ClassroomQuizActivityRetryAction",
      ClassroomQuizActivityLimitReached: "ClassroomQuizActivityLimitReached",
      ClassroomQuizActivityViewSubmissions: "ClassroomQuizActivityViewSubmissions",
      ClassroomQuizActivityHideSubmissions: "ClassroomQuizActivityHideSubmissions",
      ClassroomQuizActivitySubmissionHistoryTitle: "ClassroomQuizActivitySubmissionHistoryTitle",
      ClassroomQuizActivityLoadingSubmissions: "ClassroomQuizActivityLoadingSubmissions",
      ClassroomQuizActivityNoSubmissions: "ClassroomQuizActivityNoSubmissions",
      ClassroomQuizActivitySubmissionLabel: "ClassroomQuizActivitySubmissionLabel",
      ClassroomQuizActivityBestBadge: "ClassroomQuizActivityBestBadge",
      ClassroomQuizActivityLatestBadge: "ClassroomQuizActivityLatestBadge",
      ClassroomQuizActivityViewResultsAction: "ClassroomQuizActivityViewResultsAction",
      ManualReviewPendingTitle: "ManualReviewPendingTitle",
      ManualReviewPendingDescription: "ManualReviewPendingDescription",
      ManualReviewNoPending: "ManualReviewNoPending",
      ManualReviewColumnTitle: "ManualReviewColumnTitle",
      ManualReviewCorrectAction: "ManualReviewCorrectAction",
      ManualReviewIncorrectAction: "ManualReviewIncorrectAction",
      ManualReviewScoreLabel: "ManualReviewScoreLabel",
      ManualReviewSaveAction: "ManualReviewSaveAction",
      ManualReviewSavingAction: "ManualReviewSavingAction",
      ManualReviewSaved: "ManualReviewSaved",
      ManualReviewOpenAction: "ManualReviewOpenAction",
      ManualReviewFilterAll: "ManualReviewFilterAll",
      ManualReviewFilterNeedsReview: "ManualReviewFilterNeedsReview",
      ClassroomQuizzesPageTitle: "ClassroomQuizzesPageTitle",
      ClassroomQuizzesWorkspaceTitle: "ClassroomQuizzesWorkspaceTitle",
      ClassroomQuizzesWorkspaceDescription: "ClassroomQuizzesWorkspaceDescription",
      ClassroomQuizAttempts: "ClassroomQuizAttempts",
      ClassroomQuizAssignedStudents: "ClassroomQuizAssignedStudents",
      ClassroomQuizAverageScore: "ClassroomQuizAverageScore",
      ClassroomQuizCompletionRate: "ClassroomQuizCompletionRate",
      ClassroomQuizStudentsSectionTitle: "ClassroomQuizStudentsSectionTitle",
      ClassroomQuizStudentsSectionDescription: "ClassroomQuizStudentsSectionDescription",
      DirectQuizStudentsSectionDescription: "DirectQuizStudentsSectionDescription",
      ClassroomQuizQuestionsSectionTitle: "ClassroomQuizQuestionsSectionTitle",
      ClassroomQuizQuestionsSectionDescription: "ClassroomQuizQuestionsSectionDescription",
      ClassroomQuizLastSubmitted: "ClassroomQuizLastSubmitted",
      ClassroomQuizNoSubmissionYet: "ClassroomQuizNoSubmissionYet",
      ClassroomQuizDeadline: "ClassroomQuizDeadline",
      ClassroomQuizAssignedAt: "ClassroomQuizAssignedAt",
      ClassroomQuizCommonMistakes: "ClassroomQuizCommonMistakes",
      ClassroomQuizNoCommonMistakes: "ClassroomQuizNoCommonMistakes",
      ClassroomQuizCorrect: "ClassroomQuizCorrect",
      ClassroomQuizIncorrect: "ClassroomQuizIncorrect",
      ClassroomQuizSkipped: "ClassroomQuizSkipped",
      CorrectAnswer: "CorrectAnswer",
      TryAgainToContinue: "TryAgainToContinue",
      ClassroomQuizAccuracy: "ClassroomQuizAccuracy",
      ClassroomQuizNoTimeRecorded: "ClassroomQuizNoTimeRecorded",
      ClassroomQuizAverageDurationSecondsOnly: "ClassroomQuizAverageDurationSecondsOnly",
      ClassroomQuizAverageDurationMinutesSeconds: "ClassroomQuizAverageDurationMinutesSeconds",
      AttachmentOpenAnalytics: "AttachmentOpenAnalytics",
      AttachQuizTitle: "AttachQuizTitle",
      AttachQuizDescription: "AttachQuizDescription",
      AttachQuizSelectQuiz: "AttachQuizSelectQuiz",
      AttachQuizSelectLesson: "AttachQuizSelectLesson",
      AttachQuizSelectContent: "AttachQuizSelectContent",
      AttachQuizOptionalLesson: "AttachQuizOptionalLesson",
      AttachQuizOptionalContent: "AttachQuizOptionalContent",
      AttachQuizAssignedAtLabel: "AttachQuizAssignedAtLabel",
      AttachQuizAssignedAtHelper: "AttachQuizAssignedAtHelper",
      AttachQuizDeadlineLabel: "AttachQuizDeadlineLabel",
      AttachQuizDeadlineHelper: "AttachQuizDeadlineHelper",
      UpdateTimingAction: "UpdateTimingAction",
      UpdatingTimingAction: "UpdatingTimingAction",
      AttachQuizAction: "AttachQuizAction",
      AttachQuizRemoveAction: "AttachQuizRemoveAction",
      AttachQuizNoAvailableQuizzes: "AttachQuizNoAvailableQuizzes",
      AttachQuizConfirmDetach: "AttachQuizConfirmDetach",
      AttachQuizSelectQuizError: "AttachQuizSelectQuizError",
      NoAttachedQuizzes: "NoAttachedQuizzes",
      NoResourcesAddedYet: "NoResourcesAddedYet",
      ContentCheckpointTitle: "ContentCheckpointTitle",
      ContentCheckpointSubtitleVideo: "ContentCheckpointSubtitleVideo",
      ContentCheckpointSubtitlePdf: "ContentCheckpointSubtitlePdf",
      CheckpointQuizHelper: "CheckpointQuizHelper",
      NoQuizzesAvailableForCheckpoint: "NoQuizzesAvailableForCheckpoint",
      AddCheckpoint: "AddCheckpoint",
      NoCheckpointRules: "NoCheckpointRules",
      CheckpointQuizLabel: "CheckpointQuizLabel",
      CheckpointSecondsLabel: "CheckpointSecondsLabel",
      CheckpointPageLabel: "CheckpointPageLabel",
      CheckpointBlockingLabel: "CheckpointBlockingLabel",
      CheckpointRequired: "CheckpointRequired",
      CheckpointOptional: "CheckpointOptional",
      CheckpointReached: "CheckpointReached",
      CheckpointReachedDescription: "CheckpointReachedDescription",
      ContinueAfterCheckpoint: "ContinueAfterCheckpoint",
      OpenAttachedQuiz: "OpenAttachedQuiz",
      CheckpointAtSecond: "CheckpointAtSecond",
      CheckpointAtPage: "CheckpointAtPage",
      ContentStoredInHost: "ContentStoredInHost",
      ContentStoredPdfLink: "ContentStoredPdfLink",
      ContentStoredFileLink: "ContentStoredFileLink",
      OpenFile: "OpenFile",
      ChooseGoogleDriveFileFirst: "ChooseGoogleDriveFileFirst",
      RecaptchaUnavailable: "RecaptchaUnavailable",
      FailedToLoadGoogleDriveStatus: "FailedToLoadGoogleDriveStatus",
      AuthorizationUrlMissing: "AuthorizationUrlMissing",
      FailedToStartGoogleDriveConnection: "FailedToStartGoogleDriveConnection",
      GooglePickerUnavailable: "GooglePickerUnavailable",
      FailedToOpenGooglePicker: "FailedToOpenGooglePicker",
      GoogleDriveHeading: "GoogleDriveHeading",
      GoogleDriveConnected: "GoogleDriveConnected",
      GoogleDriveNotConnected: "GoogleDriveNotConnected",
      RefreshStatus: "RefreshStatus",
      FailedToRefreshStatus: "FailedToRefreshStatus",
      Starting: "Starting",
      Disconnecting: "Disconnecting",
      DisconnectGoogleDriveAction: "DisconnectGoogleDriveAction",
      LoadFiles: "LoadFiles",
      LoadMore: "LoadMore",
      GoogleDriveTestTitle: "GoogleDriveTestTitle",
      GoogleDriveStatusLabel: "GoogleDriveStatusLabel",
      GoogleDriveTokenExpiry: "GoogleDriveTokenExpiry",
      GoogleDriveRedirectUri: "GoogleDriveRedirectUri",
      GoogleDriveUnavailableOnServerRender: "GoogleDriveUnavailableOnServerRender",
      GoogleDriveSelectedFiles: "GoogleDriveSelectedFiles",
      GoogleDriveDisconnectSuccess: "GoogleDriveDisconnectSuccess",
      GoogleDriveDisconnectError: "GoogleDriveDisconnectError",
      GoogleDriveSelectedFilesMessage: "GoogleDriveSelectedFilesMessage",
      GoogleDriveNoFilesSelected: "GoogleDriveNoFilesSelected",
      GoogleDriveColumnName: "GoogleDriveColumnName",
      GoogleDriveColumnType: "GoogleDriveColumnType",
      GoogleDriveColumnModified: "GoogleDriveColumnModified",
      GoogleDriveColumnOpen: "GoogleDriveColumnOpen",
      Open: "Open",
      ReconnectGoogleDrive: "ReconnectGoogleDrive",
      ConnectGoogleDrive: "ConnectGoogleDrive",
      Opening: "Opening",
      ChooseFile: "ChooseFile",
      ChooseGoogleDriveFileHelp: "ChooseGoogleDriveFileHelp",
      GoogleDriveMediaBlockedHint: "GoogleDriveMediaBlockedHint",
      GoogleDrivePublicAccessRequired: "GoogleDrivePublicAccessRequired",
      GoogleDriveSharingHelpTitle: "GoogleDriveSharingHelpTitle",
      GoogleDriveSharingHelpDescription: "GoogleDriveSharingHelpDescription",
      GoogleDriveFileLink: "GoogleDriveFileLink",
      ChooseGoogleDriveFilePlaceholder: "ChooseGoogleDriveFilePlaceholder",
      GoogleDriveFileFallbackLabel: "GoogleDriveFileFallbackLabel",
      FileTypePdf: "FileTypePdf",
      FileTypeImage: "FileTypeImage",
      FileTypeSpreadsheet: "FileTypeSpreadsheet",
      FileTypePresentation: "FileTypePresentation",
      FileTypeDocument: "FileTypeDocument",
      FileTypeFile: "FileTypeFile",
      SupportedVideoProvidersHint: "SupportedVideoProvidersHint",
      VideoDetected: "VideoDetected",
      VideoDetectedDescription: "VideoDetectedDescription",
      StandardLinkDetected: "StandardLinkDetected",
      StandardLinkDescription: "StandardLinkDescription",
      UnableToCreateContent: "UnableToCreateContent",
      EmbeddedPlaybackUnavailable: "EmbeddedPlaybackUnavailable",
      EmbeddedPlaybackUnavailableDescription: "EmbeddedPlaybackUnavailableDescription",
      OpenOriginalVideo: "OpenOriginalVideo",
      VideoLabel: "VideoLabel",
      OpenLink: "OpenLink",
      YouTubeVideo: "YouTubeVideo",
      VimeoVideo: "VimeoVideo",
      LinkFromHost: "LinkFromHost",
      PdfSourceHost: "PdfSourceHost",
      PdfResource: "PdfResource",
      OpenLargerPreview: "OpenLargerPreview",
      OpenInNewTab: "OpenInNewTab",
      GoogleDrivePreviewHint: "GoogleDrivePreviewHint",
      OpenInGoogleDrive: "OpenInGoogleDrive",
      PdfExternalLinkHint: "PdfExternalLinkHint",
      OpenPdf: "OpenPdf",
      Close: "Close",
      UnableToRenderPdfInline: "UnableToRenderPdfInline",
      PdfSourceBlocksDirectAccess: "PdfSourceBlocksDirectAccess",
      OpenPdfInNewTab: "OpenPdfInNewTab",
      LoadingPdf: "LoadingPdf",
      Students: "Students",
    },
  },
  Profile: {
    Page: "Profile",
    Title: "Title",
    Current: "Current",
    Activities: "Activities",
    FoundActivities: "FoundActivities",
    FounOneActivity: "FoundOneActivity",
    Min: "Min",
    Sec: "Sec",
    Questions: "Questions",
    SpacedRepetition: "Flashcards",
    Flashcards: "Flashcards",
    PlayAndLearn: "PlayAndLearn",
    Quiz: "Quiz",
    CorrectAnswers: "CorrectAnswers",
    Name: "Name",
    NamePlaceholder: "NamePlaceholder",
    Email: "Email",
    Language: "Language",
    Country: "Country",
    Age: "Age",
    Profiles: "Profiles",
    ProfilesHelp: "ProfilesHelp",
    ProfileChess: "ProfileChess",
    ProfileLanguage: "ProfileLanguage",
    ProfileMaths: "ProfileMaths",
    ProfileCoding: "ProfileCoding",
    Password: "Password",
    Subscription: "Subscription",
    Plan: "Plan",
    RenewalDate: "RenewalDate",
    Status: "Status",
    Cancellation: "Cancellation",
    Active: "Active",
    CancelsAtPeriodEnd: "CancelsAtPeriodEnd",
    CancelRenewal: "CancelRenewal",
    Cancelling: "Cancelling",
    RenewalCancellationScheduled: "RenewalCancellationScheduled",
    RenewalCancellationFailed: "RenewalCancellationFailed",
    RenewalAlreadyStopped: "RenewalAlreadyStopped",
    YearOfBirthPlaceholder: "YearOfBirthPlaceholder",
    YearOfBirth: "YearOfBirth",
    Edit: "Edit",
    Save: "Save",
    Cancel: "Cancel",
    School: "School",
    SchoolPlaceholder: "SchoolPlaceholder",
    Region: "Region",
    RegionPlaceholder: "RegionPlaceholder",
    FindSchool: "FindSchool",
    ResultsPageTitle: "ResultsPageTitle",
    SelectQuiz: "SelectQuiz",
    NoResultsFound: "NoResultsFound",
    TotalQuestions: "TotalQuestions",
    Score: "Score",
    TypeQuestions: "TypeQuestions",
    Average: "Average",
    Date: "Date",
    AccountTab: "AccountTab",
    ChildAccountTab: "ChildAccountTab",
    AccountType: "AccountType",
    AccountTypeStudent: "AccountTypeStudent",
    AccountTypeParent: "AccountTypeParent",
    AccountTypeTeacher: "AccountTypeTeacher",
    AccountTypeTutor: "AccountTypeTutor",
    AccountTypeClaimant: "AccountTypeClaimant",
    CreateQuizzesPrompt: "CreateQuizzesPrompt",
    CreateQuizzesButton: "CreateQuizzesButton",
    ChangePassword: "ChangePassword",
    ChangePasswordTitle: "ChangePasswordTitle",
    ChangePasswordDescription: "ChangePasswordDescription",
    ChangePasswordCurrentPassword: "ChangePasswordCurrentPassword",
    ChangePasswordCurrentPasswordInvalid: "ChangePasswordCurrentPasswordInvalid",
    ChangePasswordSubmit: "ChangePasswordSubmit",
    ChangePasswordUpdating: "ChangePasswordUpdating",
    ChangePasswordSuccess: "ChangePasswordSuccess",
    ChangePasswordFailed: "ChangePasswordFailed",
    ChangePasswordRecentLogin: "ChangePasswordRecentLogin",
    ChangePasswordNoUser: "ChangePasswordNoUser",
    ChangePasswordProviderUnsupported: "ChangePasswordProviderUnsupported",
    DeleteAccount: "DeleteAccount",
    DeleteAccountTitle: "DeleteAccountTitle",
    DeleteAccountDescription: "DeleteAccountDescription",
    DeleteAccountConfirmation: "DeleteAccountConfirmation",
    DeleteAccountRecentLogin: "DeleteAccountRecentLogin",
    DeleteAccountFailed: "DeleteAccountFailed",
    DeleteAccountNoUser: "DeleteAccountNoUser",
    DeleteAccountDeleting: "DeleteAccountDeleting",
  },
  Schools: {
    PageTitle: "PageTitle",
    Title: "Title",
    Description: "Description",
    Features: {
      StudentManagement: "StudentManagement",
      ClassManagement: "ClassManagement",
      AttendanceTracking: "AttendanceTracking",
      GradeManagement: "GradeManagement",
      CommunicationTools: "CommunicationTools",
    },
    Feature2: {
      Title: "Feature2.Title",
      Description: "Feature2.Description",
    },
    Feature3: {
      Title: "Feature3.Title",
      Description: "Feature3.Description",
    },
    Promotion: {
      PreMessage: "Promotion.PreMessage",
      BeCloserToStudents: "Promotion.BeCloserToStudents",
      StreamlineYourSchoolAdministration:
        "Promotion.StreamlineYourSchoolAdministration",
      UnlockYourSchoolsPotential: "Promotion.UnlockYourSchoolsPotential",
    },
    FreeDemo: "FreeDemo",
    UserManagement: {
      Title: "UserManagement.Title",
      Description: "UserManagement.Description",
    },
    Classrooms: {
      Title: "Classrooms.Title",
      Description: "Classrooms.Description",
      Feature1_Title: "Classrooms.Feature1_Title",
      Feature1_Desc: "Classrooms.Feature1_Desc",
      Feature2_Title: "Classrooms.Feature2_Title",
      Feature2_Desc: "Classrooms.Feature2_Desc",
      Feature3_Title: "Classrooms.Feature3_Title",
      Feature3_Desc: "Classrooms.Feature3_Desc",
    },
    Quizzes: {
      Page: "Schools.Quizzes",
      Title: "Title",
      Description: "Quizzes.Description",
      Feature1_Title: "Quizzes.Feature1_Title",
      Feature1_Desc: "Quizzes.Feature1_Desc",
      Feature2_Title: "Quizzes.Feature2_Title",
      Feature2_Desc: "Quizzes.Feature2_Desc",
      AddQuizzes: "Quizzes.AddQuizzes",
      AddQuizz: "Quizzes.AddQuizz",
      YourQuizzes: "Quizzes.YourQuizzes",
    },
    Booking: {
      Title: "Booking.Title",
      Description: "Booking.Description",
    },
    Communication: {
      Title: "Communication.Title",
      Description: "Communication.Description",
    },
  },
  Bookings: {
    Title: "Title",
    PageTitle: "PageTitle",
    Description: "Description",
    UpcomingBookings: "UpcomingBookings",
    PastBookings: "PastBookings",
    NoUpcomingBookings: "NoUpcomingBookings",
    NoPastBookings: "NoPastBookings",
    NoUpcomingBookingsInRange: "NoUpcomingBookingsInRange",
    NoPastBookingsInRange: "NoPastBookingsInRange",
    BookingID: "BookingID",
    Date: "Date",
    Time: "Time",
    Participants: "Participants",
    ParticipantCount: "ParticipantCount",
    CancelBooking: "CancelBooking",
    CreateBooking: "CreateBooking",
    ViewDetails: "ViewDetails",
    LoadingBookings: "LoadingBookings",
    LoadingPastBookings: "LoadingPastBookings",
    ShowPastBookings: "ShowPastBookings",
    ShowPastBookingsCount: "ShowPastBookingsCount",
    HidePastBookings: "HidePastBookings",
    UntitledBooking: "UntitledBooking",
    StatusCancelled: "StatusCancelled",
    StatusDeclined: "StatusDeclined",
    StatusPending: "StatusPending",
    StatusConfirmed: "StatusConfirmed",
    StatusPartiallyCancelled: "StatusPartiallyCancelled",
    CancelledParticipantCount: "CancelledParticipantCount",
    DeclinedParticipantCount: "DeclinedParticipantCount",
    PendingInvitations: "PendingInvitations",
    NoPendingInvitations: "NoPendingInvitations",
    BookingDetails: "BookingDetails",
    ClassroomBadge: "ClassroomBadge",
    MeetingProviderBadge: "MeetingProviderBadge",
    JoinMeeting: "JoinMeeting",
    Close: "Close",
    CancelConfirmation: "CancelConfirmation",
    ConfirmCancel: "ConfirmCancel",
    BookingCancelled: "BookingCancelled",
    Error: "Error",
  },
  BookingDetails: {
    PageTitle: "PageTitle",
    Title: "Title",
    TitlePlaceholder: "TitlePlaceholder",
    CancelBooking: "CancelBooking",
    EditBooking: "EditBooking",
    Close: "Close",
    StartTime: "StartTime",
    EndTime: "EndTime",
    StartTimePlaceholder: "StartTimePlaceholder",
    EndTimePlaceholder: "EndTimePlaceholder",
    Add: "Add",
    InviteUser: "InviteUser",
    Name: "Name",
    NamePlaceholder: "NamePlaceholder",
    FindUser: "FindUser",
    ContactList: "ContactList",

    Date: "Date",
    Time: "Time",
    Location: "Location",
    Participants: "Participants",
    ApprovedParticipants: "ApprovedParticipants",
    CancelledParticipants: "CancelledParticipants",
    DeclinedParticipants: "DeclinedParticipants",
    PendingParticipants: "PendingParticipants",
    Status: "Status",
    Actions: "Actions",
    BookingType: "BookingType",
    BookingTypePersonal: "BookingTypePersonal",
    BookingTypeClassroom: "BookingTypeClassroom",
    Classroom: "Classroom",
    MeetingCreator: "MeetingCreator",
    ApproveMeeting: "ApproveMeeting",
    DeclineMeeting: "DeclineMeeting",
    DeclineThisMeeting: "DeclineThisMeeting",
    DeclineEntireSeries: "DeclineEntireSeries",
    ConfirmDeclineMeeting: "ConfirmDeclineMeeting",
    ConfirmDeclineSeries: "ConfirmDeclineSeries",
    SelectClassroom: "SelectClassroom",
    LoadingClassrooms: "LoadingClassrooms",
    NoClassroomsAvailable: "NoClassroomsAvailable",
    ClassroomParticipantsHelper: "ClassroomParticipantsHelper",
    NoClassroomParticipants: "NoClassroomParticipants",
    LoadingParticipants: "LoadingParticipants",
    AddMeetingLink: "AddMeetingLink",
    Recurrence: "Recurrence",
    DoesNotRepeat: "DoesNotRepeat",
    RepeatBooking: "RepeatBooking",
    RecurrenceFrequency: "RecurrenceFrequency",
    RecurrenceFrequencyWeekly: "RecurrenceFrequencyWeekly",
    RecurrenceFrequencyMonthly: "RecurrenceFrequencyMonthly",
    RecurrenceFrequencyYearly: "RecurrenceFrequencyYearly",
    RecurrenceUntil: "RecurrenceUntil",
    RecurrenceEditHelper: "RecurrenceEditHelper",
    MeetingProvider: "MeetingProvider",
    MeetingProviderManual: "MeetingProviderManual",
    MeetingProviderGoogleMeet: "MeetingProviderGoogleMeet",
    MeetingProviderMicrosoftTeams: "MeetingProviderMicrosoftTeams",
    MeetingProviderZoom: "MeetingProviderZoom",
    MeetingProviderAutoDetected: "MeetingProviderAutoDetected",
    MeetingProviderManualSelectHelper: "MeetingProviderManualSelectHelper",
    MeetingCode: "MeetingCode",
    MeetingCodePlaceholder: "MeetingCodePlaceholder",
    MeetingJoinUrl: "MeetingJoinUrl",
    MeetingJoinUrlPlaceholder: "MeetingJoinUrlPlaceholder",
    MeetingHostUrl: "MeetingHostUrl",
    MeetingHostUrlPlaceholder: "MeetingHostUrlPlaceholder",
    JoinMeeting: "JoinMeeting",
    OpenHostLink: "OpenHostLink",

    Save: "Save",
    Saving: "Saving",
    RescheduleBooking: "RescheduleBooking",
    BackToBookings: "BackToBookings",
  },
  TimesTable: {
    Page: "TimesTable",
    Eyebrow: "Eyebrow",
    BadgeSmart: "BadgeSmart",
    BadgeTablesRange: "BadgeTablesRange",
    Title: "Title",
    Intro: "Intro",
    LearningOverviewTitle: "LearningOverviewTitle",
    LearningOverviewDesc: "LearningOverviewDesc",
    SummaryFactsLabel: "SummaryFactsLabel",
    SummaryFactsValue: "SummaryFactsValue",
    SummaryFactsDesc: "SummaryFactsDesc",
    SummaryPracticeLabel: "SummaryPracticeLabel",
    SummaryPracticeValue: "SummaryPracticeValue",
    SummaryPracticeDesc: "SummaryPracticeDesc",
    SummaryTablesLabel: "SummaryTablesLabel",
    SummaryTablesValue: "SummaryTablesValue",
    SummaryTablesDesc: "SummaryTablesDesc",
    QuickChallenge: "QuickChallenge",
    TableHeading: "TableHeading",
    TableIntro: "TableIntro",
    WhyLearnTitle: "WhyLearnTitle",
    WhyLearnBody: "WhyLearnBody",
    BestOrderTitle: "BestOrderTitle",
    BestOrderBody1: "BestOrderBody1",
    BestOrderBody2: "BestOrderBody2",
    SpacedRepetitionTitle: "SpacedRepetitionTitle",
    SpacedRepetitionBody: "SpacedRepetitionBody",
    PracticeQuizzesTitle: "PracticeQuizzesTitle",
    PracticeQuizzesBody1: "PracticeQuizzesBody1",
    PracticeQuizzesBody2: "PracticeQuizzesBody2",
    PrintTable: "PrintTable",
    CSV: "CSV",
    ParentRoutineTitle: "ParentRoutineTitle",
    ParentRoutineHeading: "ParentRoutineHeading",
    ParentRoutineItem1: "ParentRoutineItem1",
    ParentRoutineItem2: "ParentRoutineItem2",
    ParentRoutineItem3: "ParentRoutineItem3",
    FAQTitle: "FAQTitle",
    FAQIntro: "FAQIntro",
    FAQ_Q1: "FAQ_Q1",
    FAQ_A1: "FAQ_A1",
    FAQ_Q2: "FAQ_Q2",
    FAQ_A2: "FAQ_A2",
    FAQ_Q3: "FAQ_Q3",
    FAQ_A3: "FAQ_A3",
    VideoSectionLabel: "VideoSectionLabel",
    VideoTitle: "VideoTitle",
    VideoIntro: "VideoIntro",
    SeeAllVideos: "SeeAllVideos",
    DownloadVideo: "DownloadVideo",
    Flashcards: "Flashcards",
    TryQuiz: "TryQuiz",
    WatchVideo: "WatchVideo",
  },
  AdditionFacts: {
    Page: "AdditionFacts",
    Eyebrow: "Eyebrow",
    BadgeSmart: "BadgeSmart",
    BadgeTablesRange: "BadgeTablesRange",
    Title: "Title",
    Intro: "Intro",
    LearningOverviewTitle: "LearningOverviewTitle",
    LearningOverviewDesc: "LearningOverviewDesc",
    SummaryFactsLabel: "SummaryFactsLabel",
    SummaryFactsValue: "SummaryFactsValue",
    SummaryFactsDesc: "SummaryFactsDesc",
    SummaryPracticeLabel: "SummaryPracticeLabel",
    SummaryPracticeValue: "SummaryPracticeValue",
    SummaryPracticeDesc: "SummaryPracticeDesc",
    SummaryTablesLabel: "SummaryTablesLabel",
    SummaryTablesValue: "SummaryTablesValue",
    SummaryTablesDesc: "SummaryTablesDesc",
    QuickChallenge: "QuickChallenge",
    TableHeading: "TableHeading",
    TableIntro: "TableIntro",
    WhyLearnTitle: "WhyLearnTitle",
    WhyLearnBody: "WhyLearnBody",
    BestOrderTitle: "BestOrderTitle",
    BestOrderBody1: "BestOrderBody1",
    BestOrderBody2: "BestOrderBody2",
    SpacedRepetitionTitle: "SpacedRepetitionTitle",
    SpacedRepetitionBody: "SpacedRepetitionBody",
    PracticeQuizzesTitle: "PracticeQuizzesTitle",
    PracticeQuizzesBody1: "PracticeQuizzesBody1",
    PracticeQuizzesBody2: "PracticeQuizzesBody2",
    PrintTable: "PrintTable",
    CSV: "CSV",
    ParentRoutineTitle: "ParentRoutineTitle",
    ParentRoutineHeading: "ParentRoutineHeading",
    ParentRoutineItem1: "ParentRoutineItem1",
    ParentRoutineItem2: "ParentRoutineItem2",
    ParentRoutineItem3: "ParentRoutineItem3",
    FAQTitle: "FAQTitle",
    FAQIntro: "FAQIntro",
    FAQ_Q1: "FAQ_Q1",
    FAQ_A1: "FAQ_A1",
    FAQ_Q2: "FAQ_Q2",
    FAQ_A2: "FAQ_A2",
    FAQ_Q3: "FAQ_Q3",
    FAQ_A3: "FAQ_A3",
    VideoSectionLabel: "VideoSectionLabel",
    VideoTitle: "VideoTitle",
    VideoIntro: "VideoIntro",
    SeeAllVideos: "SeeAllVideos",
    DownloadVideo: "DownloadVideo",
    Flashcards: "Flashcards",
    TryQuiz: "TryQuiz",
    WatchVideo: "WatchVideo",
  },
  SubtractionFacts: {
    Page: "SubtractionFacts",
    Eyebrow: "Eyebrow",
    BadgeSmart: "BadgeSmart",
    BadgeTablesRange: "BadgeTablesRange",
    Title: "Title",
    Intro: "Intro",
    LearningOverviewTitle: "LearningOverviewTitle",
    LearningOverviewDesc: "LearningOverviewDesc",
    SummaryFactsLabel: "SummaryFactsLabel",
    SummaryFactsValue: "SummaryFactsValue",
    SummaryFactsDesc: "SummaryFactsDesc",
    SummaryPracticeLabel: "SummaryPracticeLabel",
    SummaryPracticeValue: "SummaryPracticeValue",
    SummaryPracticeDesc: "SummaryPracticeDesc",
    SummaryTablesLabel: "SummaryTablesLabel",
    SummaryTablesValue: "SummaryTablesValue",
    SummaryTablesDesc: "SummaryTablesDesc",
    QuickChallenge: "QuickChallenge",
    TableHeading: "TableHeading",
    TableIntro: "TableIntro",
    WhyLearnTitle: "WhyLearnTitle",
    WhyLearnBody: "WhyLearnBody",
    BestOrderTitle: "BestOrderTitle",
    BestOrderBody1: "BestOrderBody1",
    BestOrderBody2: "BestOrderBody2",
    SpacedRepetitionTitle: "SpacedRepetitionTitle",
    SpacedRepetitionBody: "SpacedRepetitionBody",
    PracticeQuizzesTitle: "PracticeQuizzesTitle",
    PracticeQuizzesBody1: "PracticeQuizzesBody1",
    PracticeQuizzesBody2: "PracticeQuizzesBody2",
    PrintTable: "PrintTable",
    CSV: "CSV",
    ParentRoutineTitle: "ParentRoutineTitle",
    ParentRoutineHeading: "ParentRoutineHeading",
    ParentRoutineItem1: "ParentRoutineItem1",
    ParentRoutineItem2: "ParentRoutineItem2",
    ParentRoutineItem3: "ParentRoutineItem3",
    FAQTitle: "FAQTitle",
    FAQIntro: "FAQIntro",
    FAQ_Q1: "FAQ_Q1",
    FAQ_A1: "FAQ_A1",
    FAQ_Q2: "FAQ_Q2",
    FAQ_A2: "FAQ_A2",
    FAQ_Q3: "FAQ_Q3",
    FAQ_A3: "FAQ_A3",
    VideoSectionLabel: "VideoSectionLabel",
    VideoTitle: "VideoTitle",
    VideoIntro: "VideoIntro",
    SeeAllVideos: "SeeAllVideos",
    DownloadVideo: "DownloadVideo",
    Flashcards: "Flashcards",
    TryQuiz: "TryQuiz",
    WatchVideo: "WatchVideo",
  },
  DivisionFacts: {
    Page: "DivisionFacts",
    Eyebrow: "Eyebrow",
    BadgeSmart: "BadgeSmart",
    BadgeTablesRange: "BadgeTablesRange",
    Title: "Title",
    Intro: "Intro",
    LearningOverviewTitle: "LearningOverviewTitle",
    LearningOverviewDesc: "LearningOverviewDesc",
    SummaryFactsLabel: "SummaryFactsLabel",
    SummaryFactsValue: "SummaryFactsValue",
    SummaryFactsDesc: "SummaryFactsDesc",
    SummaryPracticeLabel: "SummaryPracticeLabel",
    SummaryPracticeValue: "SummaryPracticeValue",
    SummaryPracticeDesc: "SummaryPracticeDesc",
    SummaryTablesLabel: "SummaryTablesLabel",
    SummaryTablesValue: "SummaryTablesValue",
    SummaryTablesDesc: "SummaryTablesDesc",
    QuickChallenge: "QuickChallenge",
    TableHeading: "TableHeading",
    TableIntro: "TableIntro",
    WhyLearnTitle: "WhyLearnTitle",
    WhyLearnBody: "WhyLearnBody",
    BestOrderTitle: "BestOrderTitle",
    BestOrderBody1: "BestOrderBody1",
    BestOrderBody2: "BestOrderBody2",
    SpacedRepetitionTitle: "SpacedRepetitionTitle",
    SpacedRepetitionBody: "SpacedRepetitionBody",
    PracticeQuizzesTitle: "PracticeQuizzesTitle",
    PracticeQuizzesBody1: "PracticeQuizzesBody1",
    PracticeQuizzesBody2: "PracticeQuizzesBody2",
    PrintTable: "PrintTable",
    CSV: "CSV",
    ParentRoutineTitle: "ParentRoutineTitle",
    ParentRoutineHeading: "ParentRoutineHeading",
    ParentRoutineItem1: "ParentRoutineItem1",
    ParentRoutineItem2: "ParentRoutineItem2",
    ParentRoutineItem3: "ParentRoutineItem3",
    FAQTitle: "FAQTitle",
    FAQIntro: "FAQIntro",
    FAQ_Q1: "FAQ_Q1",
    FAQ_A1: "FAQ_A1",
    FAQ_Q2: "FAQ_Q2",
    FAQ_A2: "FAQ_A2",
    FAQ_Q3: "FAQ_Q3",
    FAQ_A3: "FAQ_A3",
    VideoSectionLabel: "VideoSectionLabel",
    VideoTitle: "VideoTitle",
    VideoIntro: "VideoIntro",
    SeeAllVideos: "SeeAllVideos",
    DownloadVideo: "DownloadVideo",
    Flashcards: "Flashcards",
    TryQuiz: "TryQuiz",
    WatchVideo: "WatchVideo",
  },
};
